// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cancellation-errorMessage-EqisI {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.Cancellation-btnPrimary-p5ky4 {
  border-color: var(--btn-primary-bg) !important;
  background-color: var(--btn-primary-bg) !important;
  color: var(--btn-primary-color) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}
.Cancellation-btnPrimary-p5ky4:hover,
.Cancellation-btnPrimary-p5ky4:focus,
.Cancellation-btnPrimary-p5ky4:active,
.Cancellation-btnPrimary-p5ky4:active:hover,
.Cancellation-btnPrimary-p5ky4:active:focus,
.Cancellation-btnPrimary-p5ky4[disabled]:hover,
.Cancellation-btnPrimary-p5ky4[disabled]:focus {
  border-color: var(--btn-primary-bg-hover) !important;
  background-color: var(--btn-primary-bg-hover) !important;
  color: var(--btn-primary-color) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-btnPrimaryBorder-T8RsP {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  border-radius: 6px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  text-decoration: none !important;
  border: 1px solid var(--btn-primaryBorder-color) !important;
  cursor: pointer;
  line-height: 24px;
  display: inline-block;
}
.Cancellation-btnPrimaryBorder-T8RsP:hover,
.Cancellation-btnPrimaryBorder-T8RsP:focus,
.Cancellation-btnPrimaryBorder-T8RsP:active,
.Cancellation-btnPrimaryBorder-T8RsP:active:hover,
.Cancellation-btnPrimaryBorder-T8RsP:active:focus {
  color: var(--btn-primaryBorder-color) !important;
  background-color: var(--btn-primaryBorder-bg) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-btnSecondary-ikOEJ {
  border: 1px solid var(--btn-secondary-bg) !important;
  background-color: var(--primary-white-bg) !important;
  color: var(--btn-secondary-bg) !important;
  padding: 11px 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-btnSecondary-ikOEJ:hover,
.Cancellation-btnSecondary-ikOEJ:focus,
.Cancellation-btnSecondary-ikOEJ:active,
.Cancellation-btnSecondary-ikOEJ:active:hover,
.Cancellation-btnSecondary-ikOEJ:active:focus {
  border-color: var(--btn-secondary-bg) !important;
  background-color: var(--btn-secondary-bg) !important;
  color: var(--white-text) !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-btnPrimaryLink-kXcbf {
  border: 1px solid var(--btn-primaryBorder-color) !important;
}
.Cancellation-nofocus-tcyQU:active:focus {
  background: var(--primary-white-bg) !important;
  color: var(--btn-primaryBorder-color) !important;
}
.Cancellation-btnSmall-Bd81y {
  padding: 5px 0px;
}
.Cancellation-btnBig-gPd0y {
  padding: 12px 21px !important;
}
.Cancellation-fullWidth-R0Zb6 {
  width: 100%;
}
.Cancellation-WidthAuto-T1j5_ {
  width: auto;
}
.Cancellation-fullHeight-WMc7i {
  height: 100%;
}
.Cancellation-noTextDecration-npHG1 {
  text-decoration: none !important;
}
.Cancellation-commonListStyleNone-M2rEG {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.Cancellation-btnMedium-Qoppw,
.Cancellation-btnMedium-Qoppw:hover,
.Cancellation-btnMedium-Qoppw:focus,
.Cancellation-btnMedium-Qoppw:focus:hover,
.Cancellation-btnMedium-Qoppw:active,
.Cancellation-btnMedium-Qoppw:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}
.Cancellation-btnMediumSpace-IBiqC,
.Cancellation-btnMediumSpace-IBiqC:hover,
.Cancellation-btnMediumSpace-IBiqC:focus,
.Cancellation-btnMediumSpace-IBiqC:focus:hover,
.Cancellation-btnMediumSpace-IBiqC:active,
.Cancellation-btnMediumSpace-IBiqC:active:hover {
  padding-inline: 19px !important;
  white-space: normal;
}
.Cancellation-btnMediumPadding-ajNAo,
.Cancellation-btnMediumPadding-ajNAo:hover,
.Cancellation-btnMediumPadding-ajNAo:focus,
.Cancellation-btnMediumPadding-ajNAo:active,
.Cancellation-btnMediumPadding-ajNAo:active:hover,
.Cancellation-btnMediumPadding-ajNAo:focus:hover {
  padding: 12px 19px;
}
.Cancellation-aiAskButton-H2EJd {
  padding: 12px 18px;
  border: unset !important;
  outline: unset !important;
  border-radius: 24px 24px 24px 6px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--primary-foreground);
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021 !important;
          box-shadow: 0px 2px 6px 0px #EA672021 !important;
  background: var(--ai-badge-bg) !important;
  position: relative;
  opacity: 1 !important;
}
.Cancellation-aiBadgeStyle-F2EIW {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  gap: 4px;
  background: var(--ai-badge-bg);
  border-radius: 100px;
  position: relative;
  -webkit-box-shadow: 0px 2px 6px 0px #EA672021;
          box-shadow: 0px 2px 6px 0px #EA672021;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  padding: 4px 12px;
}
.Cancellation-aiTextColor-Hgywz {
  background: var(--ai-foreground);
  -webkit-background-clip: text;
          background-clip: text;
  -webkit-text-fill-color: transparent;
}
.Cancellation-aiBadgeStyle-F2EIW>svg {
  position: relative;
  top: 2px;
}
.Cancellation-aiAskButton-H2EJd::after,
.Cancellation-aiBadgeStyle-F2EIW::after {
  content: '';
  position: absolute;
  inset: -1px;
  background: var(--ai-border);
  border-radius: inherit;
  z-index: -1;
}
.Cancellation-aiFooterInfoText-_NOX4 {
  font-size: 12px;
  line-height: 18px;
  color: var(--secondary-foreground);
  display: inline-block;
  font-weight: 500;
}
.Cancellation-regenerateBtn-dSJau {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 4px;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  border: 0;
  padding: 0px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.Cancellation-regenerateBtn-dSJau>svg {
  position: relative;
  top: 3px;
}
/************************ text Align ************************/
.Cancellation-textAlignRight-DacN1 {
  text-align: right;
}
.Cancellation-textAlignLeft-okzAh {
  text-align: left;
}
.Cancellation-textAlignCenter-bxLnm {
  text-align: center;
}
/************************ text Align end ******************/
.Cancellation-formControlInput-kp2nJ {
  padding: 10px 19px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  line-height: 24px;
  color: var(--common-text-color);
  font-weight: normal;
  border: 1px solid transparent;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-formControlSelect-cRO70 {
  padding: 10px 35px 10px 19px;
  height: 48px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--primary-border) !important;
  background-color: var(--primary-white-bg);
  color: var(--common-text-color);
  line-height: 19px;
  font-weight: normal;
  display: block;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-noTextDecoration-YYJR9 {
  text-decoration: none !important;
}
/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */
.Cancellation-picContainerMain-PYdP_ {
  position: relative;
}
.Cancellation-profilePic-vOKRQ {
  height: 100%;
  width: 100%;
  border-radius: 12px;
}
.Cancellation-trashIcon-G2qDW {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: 22px;
  background: var(--common-background-color);
  padding-top: 3px;
  border: 0;
  border-radius: 2px;
  opacity: .9;
  color: var(--white-text);
  cursor: pointer;
}
.Cancellation-trashIconNew-ZLfyd {
  position: absolute;
  top: 18px;
  right: 18px;
}
.Cancellation-trashIconNew-ZLfyd img {
  width: 36px;
}
.Cancellation-bannerImageBg-VVjBm {
  width: 100%;
  height: 100%;
  min-height: 179px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: relative;
  border-radius: 0px;
}
.Cancellation-profileImageBg-qb4B1 {
  padding-top: 36%;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 100%;
  max-width: 180px;
  margin: 0 auto;
  background-position: 50% 50%;
  background-size: 66px;
}
.Cancellation-whiteImg-VqYMg {
  background: var(--modalText-color);
  border-radius: 0px;
}
.Cancellation-curserPointer-Vbcj8 {
  cursor: pointer;
}
.Cancellation-adminLabelTextNew-N1WG4 {
  font-size: 18px;
  font-weight: 500;
  color: var(--common-text-color);
}
/*-----------------------Profilephoto Upload Common Styles End----------------------------- */
/******************* Admin Modal ListSetting Start *******************/
.Cancellation-radioBtn-ak8w6 {
  position: relative;
  top: 1px;
  vertical-align: middle;
  margin-left: 3px;
}
.Cancellation-displayinlineBlock-F69cd {
  display: inline-block;
}
.Cancellation-displayBlock-qDaOO {
  display: block;
}
.Cancellation-displayFlex-W4MK9 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.Cancellation-inlineDisplayFlex-RYrl6 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
}
.Cancellation-alignCenter-GBb0Y {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.Cancellation-spaceBetween-A4tPs {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.Cancellation-alignItemFlexStart-utKE6 {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}
/******************* Admin Modal ListSetting Start *******************/
.Cancellation-commonTitleText-yjoNl {
  font-size: 36px;
  margin: 0px;
  word-wrap: break-word;
}
.Cancellation-commonSubTitleText-ANPD1 {
  font-size: 20px;
  margin: 0px;
}
.Cancellation-commonContentText-VGV6J {
  font-size: 18px;
  margin: 0px;
}
.Cancellation-commonMediumText-Cz0Ps {
  font-size: 16px;
  margin: 0px;
}
.Cancellation-commonTotalText-Nz6GT {
  font-size: 24px;
  margin: 0px;
}
.Cancellation-commonSmallText-rsW33 {
  font-size: 14px;
  margin: 0px;
}
.Cancellation-fontWeightExtraBold-ypLiV {
  font-weight: 700;
}
.Cancellation-fontWeightBold-iOLrS {
  font-weight: 600;
}
.Cancellation-fontWeightMedium-goj0m {
  font-weight: 500;
}
.Cancellation-fontWeightNormal-cx6yv {
  font-weight: 400;
}
.Cancellation-textDecorationUnderLine-XlfOr {
  text-decoration: underline;
}
.Cancellation-textDecorationNone-h4Ypz {
  text-decoration: none !important;
}
.Cancellation-siteLinkColor-Y1zbY,
.Cancellation-siteLinkColor-Y1zbY:hover,
.Cancellation-siteLinkColor-Y1zbY:focus,
.Cancellation-siteLinkColor-Y1zbY:active {
  color: var(--common-link-color);
}
.Cancellation-commonLinkBorderBottom-d0M20 {
  border-bottom: 1px solid var(--common-link-color);
}
.Cancellation-siteTextColor-Hk8hq,
.Cancellation-siteTextColor-Hk8hq:hover,
.Cancellation-siteTextColor-Hk8hq:focus,
.Cancellation-siteTextColor-Hk8hq:active {
  color: var(--common-text-color);
}
.Cancellation-positionRelative-_QI_2 {
  position: relative;
}
.Cancellation-listingHorizoltalLine-Jmcb2 {
  margin: 40px 0px;
  border-top: 1px solid var(--primary-border);
}
/******************************* Common Margin Start *****************************/
.Cancellation-spaceBottom0-p0751 {
  margin-bottom: 0px;
}
.Cancellation-spaceBottom1-uoAAK {
  margin-bottom: 6px;
}
.Cancellation-spaceBottom2-TjOb5 {
  margin-bottom: 12px;
}
.Cancellation-spaceBottom3-kuoaw {
  margin-bottom: 18px;
}
.Cancellation-spaceBottom4-opsn1 {
  margin-bottom: 24px;
}
.Cancellation-spaceBottom5-Y8NCb {
  margin-bottom: 30px;
}
.Cancellation-spaceBottom6-QdSCY {
  margin-bottom: 36px;
}
.Cancellation-spaceBottom7-nLb9d {
  margin-bottom: 42px;
}
.Cancellation-spaceBottom8-gKmvQ {
  margin-bottom: 10px;
}
.Cancellation-spaceTop0-vs9jj {
  margin-top: 0px;
}
.Cancellation-spaceTop1-UkWSE {
  margin-top: 6px;
}
.Cancellation-spaceTop2-i9Xtj {
  margin-top: 12px;
}
.Cancellation-spaceTop3-gcMRt {
  margin-top: 18px;
}
.Cancellation-spaceTop4-r5dPf {
  margin-top: 24px;
}
.Cancellation-spaceTop5-uXGr0 {
  margin-top: 30px;
}
.Cancellation-spaceTop6-rF17q {
  margin-top: 36px;
}
.Cancellation-spaceTop7-TPtJI {
  margin-top: 42px;
}
.Cancellation-paddingBottom1-JcDeX {
  padding-bottom: 6px;
}
.Cancellation-paddingBottom2-TZWcR {
  padding-bottom: 12px;
}
.Cancellation-paddingBottom3-k_iPl {
  padding-bottom: 18px;
}
.Cancellation-paddingBottom4-tcwRV {
  padding-bottom: 24px;
}
.Cancellation-paddingBottom5-yyhXi {
  padding-bottom: 30px;
}
.Cancellation-paddingBottom6-HEvlt {
  padding-bottom: 36px;
}
.Cancellation-paddingBottom7-sxsru {
  padding-bottom: 42px;
}
.Cancellation-paddingTop1-cGnA8 {
  padding-top: 6px;
}
.Cancellation-paddingTop2-_iMaz {
  padding-top: 12px;
}
.Cancellation-paddingTop3-HIEsv {
  padding-top: 18px;
}
.Cancellation-paddingTop4-SBgoz {
  padding-top: 24px;
}
.Cancellation-paddingTop5-dAkgV {
  padding-top: 30px;
}
.Cancellation-paddingTop6-RFUit {
  padding-top: 36px;
}
.Cancellation-paddingTop7-YVVFK {
  padding-top: 42px;
}
.Cancellation-spaceRight1-u44LZ {
  margin-right: 6px;
}
.Cancellation-spaceRight2-C9TcS {
  margin-right: 12px;
}
.Cancellation-spaceRight3-xWbyO {
  margin-right: 18px;
}
.Cancellation-spaceRight4-JTpES {
  margin-right: 24px;
}
.Cancellation-paddingBottom8-zf6Pe {
  padding-bottom: 15px;
}
.Cancellation-spaceTop8-wsbTm {
  margin-top: 16px;
}
.Cancellation-paddingBottomNone-Aw7Ud {
  padding-bottom: 0;
}
.Cancellation-spaceBottom9-PntH4 {
  margin-bottom: 16px;
}
.Cancellation-spaceBottom10-H33VV {
  margin-bottom: 17px;
}
.Cancellation-spaceBottom11-MYzSj {
  margin-bottom: 7px;
}
.Cancellation-spaceBottom12-ymoNA {
  margin-bottom: 20px;
}
.Cancellation-noPadding-Ca26q {
  padding: 0px;
}
.Cancellation-flexShrinkNone-d46rz {
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
/******************************* Common Margin And Padding End *****************************/
.Cancellation-viewListIcon-aAhiq {
  width: 100%;
  max-width: 35px;
  min-width: 35px;
}
.Cancellation-blueLeftArrow-knj33 {
  padding-left: 6px;
  position: relative;
}
.Cancellation-profileAvatarLink-putbE {
  border: 2.5px solid var(--common-link-color);
  border-radius: 50%;
  display: inline-block;
  padding: 7px;
  background-color: var(--dashBoard-info-bg);
}
.Cancellation-profileAvatarLinkSmall-k3N3d {
  padding: 2px
}
.Cancellation-errorMessage-EqisI {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.Cancellation-textTransformLowerCase-VXWrE {
  text-transform: lowercase;
}
.Cancellation-passwordIcon-SeuEJ {
  position: absolute;
  right: 18px;
  top: 43px;
  cursor: pointer;
}
.Cancellation-noMargin-efhhi {
  margin: 0px;
}
.Cancellation-noMarginBottom-TUgt4 {
  margin-bottom: 0 !important;
}
.Cancellation-dotCss-O4AmJ {
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  margin: 0px 4px;
  display: inline-block;
  position: relative;
  top: -3px;
}
.Cancellation-dateArrowMargin-RWE2W {
  margin: 0px 8px;
}
.Cancellation-commonBorderSection-mOaty {
  --wrapper-Padding: 24px;
  border: 1px solid var(--primary-border);
  padding: 18px var(--wrapper-Padding);
  border-radius: 12px;
}
.Cancellation-vtrMiddle-v62uE {
  vertical-align: middle;
}
.Cancellation-positionAvatar-_R4Yy {
  position: absolute;
  top: 15px;
  right: 15px;
}
/* display flex properties */
.Cancellation-dFlex-LkZ73 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.Cancellation-flexWrap-resjy {
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.Cancellation-dInlineFlex-arF3q {
  display: inline-block;
  display: -webkit-inline-box;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.Cancellation-dFlexContainer-nMhED {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.Cancellation-dFlexWrap-HXHwA {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
}
.Cancellation-dFlexWrapAlignEnd-roRhm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.Cancellation-dFlexWrapAlignStart-Jr33r {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  display: -webkit-flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}
.Cancellation-justifyContentSpaceBetween-pIZZ1 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.Cancellation-greyText-XvmR7 {
  color: var(--modalText-color);
}
.Cancellation-tripsReservationPanel-Wd3BM {
  border-radius: 12px;
  width: 100%;
  display: block;
  border: 1px solid var(--primary-border);
  background: var(--primary-white-bg);
  padding: 15px 24px 24px 24px;
}
.Cancellation-listContainer-KxXIl {
  margin: 0px;
  padding: 0px;
  list-style: none;
  border-bottom: 1px solid var(--primary-border);
}
.Cancellation-listTabItem-w7zy8 {
  display: block;
  padding: 0px 0px 7px;
  position: relative;
  text-align: center;
  font-size: 18px;
  color: var(--modalText-color);
  cursor: pointer;
  border-bottom: 1px solid transparent;
  margin-right: 30px;
}
.Cancellation-listTabItem-w7zy8:hover,
.Cancellation-listTabItem-w7zy8:active,
.Cancellation-listTabItem-w7zy8:focus,
.Cancellation-listTabItem-w7zy8:active:hover,
.Cancellation-listTabItem-w7zy8:focus:hover {
  text-decoration: none;
  color: var(--common-text-color);
}
.Cancellation-reviewsContainer-JE1p3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-column-gap: 6px;
     -moz-column-gap: 6px;
          column-gap: 6px;
}
.Cancellation-reviewsYourItemsOne-qsabh {
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}
.Cancellation-reviewsYourItemsTwo-DByLL {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
}
.Cancellation-rightBg-hOs_Z {
  background: var(--common-gray-bg-color);
  border-radius: 0 8px 8px 8px;
  padding: 16px 18px 18px 18px;
  width: 100%;
  position: relative;
  -webkit-border-radius: 0 8px 8px 8px;
  -moz-border-radius: 0 8px 8px 8px;
  -ms-border-radius: 0 8px 8px 8px;
  -o-border-radius: 0 8px 8px 8px;
}
.Cancellation-commonProfileAvatarLink-aSIwE {
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  width: 68px;
  height: 68px;
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid var(--common-link-color);
  background-color: transparent;
  padding: 3px;
  position: relative;
  z-index: 5;
}
.Cancellation-commonProfileAvatarLink-aSIwE img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  background-color: var(--primary-white-bg);
  border-radius: 50%;
}
.Cancellation-writtenReviewTitle-SfEPk {
  font-weight: 500;
  margin-bottom: 6px;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}
.Cancellation-reviewTitleLink-FlPvz {
  color: var(--common-link-color);
  font-weight: 500;
}
.Cancellation-reviewTitleLink-FlPvz:hover,
.Cancellation-reviewTitleLink-FlPvz:focus,
.Cancellation-reviewTitleLink-FlPvz:active,
.Cancellation-reviewTitleLink-FlPvz:active:hover {
  color: var(--common-link-color);

}
.Cancellation-reviewFlex-Shjb1 {
  -webkit-column-gap: 5px;
     -moz-column-gap: 5px;
          column-gap: 5px;
  font-size: 14px;
  color: var(--common-text-color);
  margin-bottom: 6px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.Cancellation-noTop-fzyAy {
  top: 0;
}
.Cancellation-reviewPara-mERO0 {
  color: var(--common-text-color);
  word-break: break-word;
}
.Cancellation-dFlexColumn-uYZmy {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.Cancellation-commonlineCss-zN3Wy {
  margin: 18px 0;
  border: 1px solid var(--primary-border);
}
.Cancellation-rightBg-hOs_Z::after {
  content: "";
  position: absolute;
  left: -38px;
  top: 0;
  right: auto;
  width: 38px;
  height: 40px;
  background: var(--primary-white-bg);
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  z-index: 3;
}
.Cancellation-rightBg-hOs_Z::before {
  content: " ";
  position: absolute;
  display: inline-block;
  width: 0;
  height: 0;
  bottom: auto;
  border: 10px solid transparent;
  border-left: 0;
  border-right-color: var(--primary-white-bg);
  top: 0;
  left: auto;
  right: 100%;
  border-width: 0 24px 24px 0;
  border-color: transparent #F9F9F9 transparent transparent;
}
.Cancellation-loadBtn-N2qvd {
  border-color: var(--btn-primary-bg);
  color: var(--white-text);
  height: 48px;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background: var(--btn-primary-bg);
  border-radius: 6px;
  padding: 12px 19px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}
.Cancellation-loadBtn-N2qvd:hover,
.Cancellation-loadBtn-N2qvd:active,
.Cancellation-loadBtn-N2qvd:focus,
.Cancellation-loadBtn-N2qvd:active:hover,
.Cancellation-loadBtn-N2qvd:active:focus,
.Cancellation-loadBtn-N2qvd[disabled]:hover,
.Cancellation-loadBtn-N2qvd[disabled]:focus {
  color: var(--white-text);
  border-color: var(--btn-primary-bg);
  background: var(--btn-primary-bg);
}
.Cancellation-vtrTop-Vfzp1 {
  vertical-align: top;
}
.Cancellation-reviewHeadingColor-T2yJD {
  color: var(--common-text-color);
}
.Cancellation-reviewWriteHeading-oGJ2j {
  font-weight: 500;
  word-break: break-word;
  color: var(--common-text-color);
  font-size: 18px;
}
.Cancellation-noDataImgSize-ptLZP {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
.Cancellation-justifyCenter-dJ7xb {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.Cancellation-btnTextBrk-sl6kC {
  white-space: normal;
  word-break: break-word;
}
.Cancellation-marginInlineAuto-LtsBg {
  margin-inline: auto;
}
.Cancellation-noItemPanel-DK431 {
  background: var(--primary-white-bg);
  border-radius: 12px;
  border: 1px solid var(--primary-border);
  padding: 44px 0;
}
.Cancellation-textLineBreak-N42dI {
  word-break: break-word;
}
.Cancellation-displayBlock-qDaOO {
  display: block;
}
.Cancellation-displayInlineBlock-eWqz_ {
  display: inline-block;
}
.Cancellation-commonContainerList-XWTBf {
  width: 100%;
  max-width: var(--max-listing-width);
  margin: 0 auto;
}
.Cancellation-adminBorderWithoutPadding-PyIwj {
  border: 1px solid var(--primary-border);
  border-radius: 4px;
}
.Cancellation-marginRight8-GBLGL {
  margin-right: 8px;
}
.Cancellation-adminDotIconBtn-laNTt,
.Cancellation-adminDotIconBtn-laNTt:hover,
.Cancellation-adminDotIconBtn-laNTt:focus,
.Cancellation-adminDotIconBtn-laNTt:active {
  border: none;
  background-color: transparent !important;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}
.Cancellation-commonLinkBorder-zvaQ9 {
  border-bottom: 1px solid var(--common-link-color);
}
.Cancellation-commonTabelDropDownBg-ywsSE {
  background: var(--common-gray-bg-color);
  -webkit-box-shadow: 0px 3px 6px #00000029;
          box-shadow: 0px 3px 6px #00000029;
  border-radius: 6px;
  padding: 10px;
}
.Cancellation-tabelDropDownBtn-Le1M8,
.Cancellation-tabelDropDownBtn-Le1M8:hover,
.Cancellation-tabelDropDownBtn-Le1M8:active,
.Cancellation-tabelDropDownBtn-Le1M8:focus {
  padding: 12px 10px !important;
  border: none;
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
  background-color: transparent !important;
  font-size: 16px;
  color: var(--common-text-color);
  line-height: inherit;
  vertical-align: top;
  border-radius: 0;
}
.Cancellation-tableHorizantalLine-BvNe9 {
  border-color: var(--primary-border);
  margin: 6px 0px;
}
.Cancellation-backArrowStyle-iLncF {
  width: 15px;
  height: 12px;
  margin-right: 6px;
}
.Cancellation-csvImageSpace-kDxi7 {
  margin: 0px 6px;
}
.Cancellation-flexEnd-ifUGb {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}
.Cancellation-justifyContentFlexEnd-l2Lc4 {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.Cancellation-profileAvatarLinkPayment-kEOPA {
  padding: 5px;
}
.Cancellation-alignItemBaseline-yhIE3 {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}
.Cancellation-payOutToolTip-e4MQT {
  margin: 0 3px;
}
.Cancellation-tolltipMargin-gJqY2 {
  margin: 0 3px;
}
.Cancellation-textNoWrap-_uHXH {
  white-space: nowrap;
}
.Cancellation-commonSearchInputFilterContainer-Xwa42 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 16px;
  grid-gap: 16px;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
.Cancellation-mobileTableSearch-msLnE {
  margin-bottom: 24px;
  gap: 16px;
  grid-gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.Cancellation-mobileTableOnlyLink-YFc2Z {
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.Cancellation-linkBtnPrimaryStyle-eO5gj {
  background-color: transparent !important;
  color: var(--common-link-color);
  padding: 0;
  border: unset;
  -webkit-box-shadow: unset !important;
          box-shadow: unset !important;
  border-bottom: 1px solid var(--common-link-color);
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  line-height: 26px;
  border-radius: 0 !important;
  white-space: normal;
}
.Cancellation-linkBtnPrimaryStyle-eO5gj:hover,
.Cancellation-linkBtnPrimaryStyle-eO5gj:focus,
.Cancellation-linkBtnPrimaryStyle-eO5gj:active,
.Cancellation-linkBtnPrimaryStyle-eO5gj:active:hover {
  color: var(--common-link-color);
  border-bottom: 1px solid var(--common-link-color);
}
.Cancellation-dataTableGrid-e0ja5 {
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 4px;
}
.Cancellation-paymentDivider-IbMPZ {
  border-bottom: 1px solid var(--primary-border);
  padding-bottom: 12px;
  margin-bottom: 12px;
}
.Cancellation-paymentDivider-IbMPZ:last-child {
  border-bottom: unset;
  margin-bottom: 0;
  padding-bottom: 0;
}
.Cancellation-bulletList-SYfXN {
  list-style: disc;
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
}
.Cancellation-commonSmallText14-MU35F {
  font-size: 14px;
  line-height: 20px;
}
.Cancellation-commonSmallText16-VbgZe {
  font-size: 16px;
  line-height: 22px;
}
.Cancellation-commonSmallText18-bUsAo {
  font-size: 18px;
  line-height: 24px;
}
.Cancellation-commonSmallText20-CkUCV {
  font-size: 20px;
  line-height: 26px;
}
.Cancellation-commonSmallText24-Z_BQb {
  font-size: 24px;
  line-height: 30px;
}
.Cancellation-commonSmallText26-X3N72 {
  font-size: 26px;
  line-height: normal;
}
.Cancellation-top1-hOGv4 {
  top: 1px;
}
.Cancellation-top2-zdezH {
  top: 2px;
}
.Cancellation-top3-DNnqM {
  top: 3px
}
.Cancellation-topMinus1-C26MJ {
  top: -1px;
}
.Cancellation-topMinus2-xsoXg {
  top: -2px;
}
.Cancellation-topMinus3-fDpOX {
  top: -3px
}
.Cancellation-textEnd-CJGzV {
  text-align: end;
}
.Cancellation-textAlignCenter-bxLnm {
  text-align: center;
}
.Cancellation-textStart-orr6s {
  text-align: start;
}
.Cancellation-flexGrow-yafyE {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}
/* dropzone */
.Cancellation-imageUploadDropzoneSection-ZTpL9 {
  border-radius: 12px;
  width: 100%;
  height: 180px;
  position: relative;
}
.Cancellation-imageUploadDropzoneSectionOutline-kPSV_ {
  background-color: var(--secondary-gray-bg);
  border: 2px dashed var(--primary-border);
}
.Cancellation-commonDropZoneImgContainer-FyYAz {
  position: absolute;
  inset: 0;
  -o-object-fit: contain;
     object-fit: contain;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  -o-object-position: center;
     object-position: center;
  background-size: contain;
  background-position: center;
}
.Cancellation-commonDropZoneDefaultImg-nCP4p {
  background-size: 70px 70px;
}
.Cancellation-navTabFlex-VA94K {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px 30px;
  border-bottom: 1px solid var(--primary-border);
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
}
.Cancellation-navTabLink-wQkPO {
  font-size: 18px;
  line-height: 24px;
  color: var(--tertiary-foreground) !important;
  padding-bottom: 6px;
  text-decoration: none !important;
  position: relative;
  text-align: center;
  display: block;
  cursor: pointer;
}
.Cancellation-navTabLink-wQkPO.Cancellation-activeTabStyle-VW0Yd {
  color: var(--primary-foreground) !important;
  font-weight: 500;
}
.Cancellation-navTabLink-wQkPO.Cancellation-activeTabStyle-VW0Yd::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: var(--primary-link-foreground) !important;
  bottom: -1px;
  left: 0;
  right: 0;
}
.Cancellation-listingCardCarTypeAndTransmissionLabelFlexContainer-SXjUh {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
  color: var(--primary-foreground);
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.Cancellation-listingCardCarTypeAndTransmissionLabelFlexContainer-SXjUh>div {
  max-width: 50%;
}
.Cancellation-transmissionLabelText-VKfzh {
  position: relative;
  -webkit-padding-start: 15px;
          padding-inline-start: 15px;
}
.Cancellation-transmissionLabelText-VKfzh::before {
  content: '';
  position: absolute;
  width: 4px;
  height: 4px;
  background: var(--common-background-color);
  border-radius: 50%;
  left: 5px;
  top: 8px;
}
.Cancellation-carTypeIcon-eHFnb {
  position: relative;
  top: -2px;
}
.Cancellation-textFlow-tEwse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media screen and (min-width:992px) {
  .Cancellation-paymentSticky-pwyOu {
    position: sticky !important;
    position: -webkit-sticky;
    top: 42px
  }
}
@media (max-width: 1024px) and (min-width: 768px) {
  .Cancellation-dateArrowMargin-RWE2W {
    margin: 0px -10px;
  }
}
@media screen and (max-width: 767px) {
  .Cancellation-btnWidth-BPvTY {
    width: 100%;
  }

  .Cancellation-mobTextCenter-VBVPL {
    text-align: center !important;
  }

  .Cancellation-tripsReservationPanel-Wd3BM {
    padding-inline: 15px;
  }

  .Cancellation-listContainer-KxXIl {
    border-bottom: unset;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .Cancellation-listContainer-KxXIl li .Cancellation-listTabItem-w7zy8 {
    margin-right: 0;
    margin-left: 0;
  }

  .Cancellation-writtenReviewTitle-SfEPk,
  .Cancellation-reviewTitleLink-FlPvz {
    font-size: 16px;
  }

  .Cancellation-reviewFlex-Shjb1 {
    font-size: 12px;
  }

  .Cancellation-reviewPara-mERO0 {
    font-size: 14px;
  }

  .Cancellation-commonProfileAvatarLink-aSIwE {
    width: 50px;
    height: 50px;
  }

  .Cancellation-reviewWriteHeading-oGJ2j {
    font-size: 16px;
  }

  .Cancellation-mobileReviewIconBox-gcMeF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .Cancellation-mrMarginBottom-hgisA {
    margin-bottom: 5px;
  }

  .Cancellation-mrRemoveMargin-qksCZ {
    margin-right: 0;
  }

  .Cancellation-mrListDeletBtnBox-hYy6z {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .Cancellation-mobileFlexContainer-q0hnX {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .Cancellation-mobileFlexContainer-q0hnX li {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }

  .Cancellation-mobileDisplayBlock-YhtiK {
    display: block;
  }

  .Cancellation-mobileTextCenter-jy5ei {
    text-align: center;
  }

  .Cancellation-profileImageBg-qb4B1,
  .Cancellation-bannerImageBg-VVjBm {
    padding-top: 60%;
  }

  .Cancellation-trashIconNew-ZLfyd {
    top: 12px;
    right: 12px;
  }

  .Cancellation-mobileTableSearch-msLnE {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
  }

  .Cancellation-commonBorderSection-mOaty {
    --wrapper-Padding: 18px;
  }

  .Cancellation-commonSearchInputFilterContainer-Xwa42 {
    width: 100%;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
  }

  .Cancellation-mobileTableOnlyLink-YFc2Z {
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: flex-end;
  }

  .Cancellation-navTabFlex-VA94K {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
    border: unset;
  }
}
.Cancellation-displayGrid-R9bDw {
  display: grid;
}
.Cancellation-gridCols2-gVhag {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.Cancellation-gap4-Bji3E {
  gap: 4px;
}
.Cancellation-gap6-uyy0H {
  gap: 6px;
}
.Cancellation-gap8-uDqzv {
  gap: 8px;
}
.Cancellation-gap12-PZpIz {
  gap: 12px;
}
.Cancellation-gap16-jtbj6 {
  gap: 16px;
}
.Cancellation-gap24-LQx9t {
  gap: 24px;
}
.Cancellation-columnGap16-HD5ps {
  -webkit-column-gap: 16px;
     -moz-column-gap: 16px;
          column-gap: 16px;
}
.Cancellation-rowGap18-Qv8Au {
  row-gap: 18px;
}
.Cancellation-bt-AC4XL {
  border-top: 1px solid var(--primary-border);
}
.Cancellation-languageBox-dExBc>div:not(:first-child) {
  padding-top: 24px;
  border-top: 1px solid var(--primary-border);
  margin-top: 24px;
}
.Cancellation-languageBtnContainerOne-rdqot {
  margin-bottom: 24px;
}
.Cancellation-languageBox-dExBc>div:last-child .Cancellation-languageBtnContainerOne-rdqot {
  margin-bottom: 0;
}
.Cancellation-commonInputGrpDivider-k0XCd {
  padding-bottom: 18px;
  border-bottom: 1px solid var(--primary-border);
}
@media screen and (max-width: 991px) {
  .Cancellation-gridColsTab1-mZfc0 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .Cancellation-gapTab0-lhJrT {
    gap: 0px !important;
  }
}
@media screen and (max-width: 767px) {
  .Cancellation-gridColsMobile1-g65hU {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .Cancellation-mobileFlexColumn-d75HU {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .Cancellation-mobileAlignFlexStretch-t6CBt {
    -webkit-box-align: stretch;
        -ms-flex-align: stretch;
            align-items: stretch;
  }
}
.Cancellation-Cancel-container-1VRb7-BF1Y5 {
	margin: 0px auto;
	max-width: 1080px;
}
.Cancellation-textAreaInput-Iighf {
	height: 187px !important;
	padding: 14px 19px;
	border-color: var(--primary-border);
	border-radius: 6px;
	font-size: 16px !important;
	resize: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.Cancellation-textTruncate-ChL34 {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.Cancellation-noPadding-Ca26q {
	padding: 0px;
}
.Cancellation-profileAvatarSection-C3Kat {
	position: absolute;
	top: 11px;
	right: 12px;

}
.Cancellation-profileAvatarLink-putbE {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	border-radius: 50%;
	border: 2px solid var(--common-link-color);
}
.Cancellation-textRight-vMDjT {
	text-align: right;
}
.Cancellation-textLeft-aWTFv {
	text-align: left;
}
.Cancellation-cancelBg-NAGW9 {
	width: 100%;
	height: 100%;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	border-radius: 6px;
}
.Cancellation-bgCover-ffsT8 {
	width: 100%;
	height: 199px;
	position: relative;
	border-radius: 6px;
}
.Cancellation-profileAvatar-xaBLP {
	background: transparent;
	border-radius: 50%;
}
.Cancellation-carTypeTextSec-NeQRH {
	width: 100%;
	margin-bottom: 8px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.Cancellation-steeringIcon-Pr0sv {
	width: 14px;
	height: 14px;
	-o-object-fit: contain;
	   object-fit: contain;
	margin-right: 3px;
}
.Cancellation-cancelRightCol-S2Gv_ {
	background: var(--common-gray-bg-color);
	margin-top: 10px;
}
.Cancellation-carType-kJVAZ {
	white-space: nowrap;
	overflow: hidden;
}
.Cancellation-dotStyle-yzl3n {
	top: 0;
	margin-inline: 4px;
}
.Cancellation-listingTitle-LmC0T,
.Cancellation-listingTitle-LmC0T:hover,
.Cancellation-listingTitle-LmC0T:focus,
.Cancellation-listingTitle-LmC0T:active,
.Cancellation-listingTitle-LmC0T:active:hover,
.Cancellation-listingTitle-LmC0T:focus:hover {
	color: var(--common-text-color);
}
.Cancellation-listingTitle-LmC0T:hover,
.Cancellation-listingTitle-LmC0T:focus,
.Cancellation-listingTitle-LmC0T:active,
.Cancellation-listingTitle-LmC0T:active:hover,
.Cancellation-listingTitle-LmC0T:focus:hover {
	text-decoration: underline;
}
.Cancellation-listingTitleSec-D2Jjx {
	margin-bottom: 7px;
}
.Cancellation-starIcon-ubHSr {
	width: 14px;
	height: 14px;
	-o-object-fit: contain;
	   object-fit: contain;
	margin-right: 3px;
}
.Cancellation-cancelPayDetails-dlCoa {
	padding: 24px;
	border-radius: 12px;
}
.Cancellation-guestFundSec-bXx6s {
	background-color: var(--cancel-refund-bg);
	border: 1px solid var(--cancel-refund-border);
}
.Cancellation-hostFundSec-CEJZj {
	background-color: var(--cancel-bg);
	border: 1px solid var(--cancel-border);
}
.Cancellation-missedEarningsIcon-U7a1N {
	width: 22px;
	height: 22px;
	margin-right: 8px;
	-o-object-fit: contain;
	   object-fit: contain;
}
.Cancellation-rightSecWidth-AvFK0 {
	width: 45%;
}
.Cancellation-leftSecWidth-KmwSh {
	width: 55%;
}
.Cancellation-strikeOutLine-Iyvf_ {
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--strike-line);
}
.Cancellation-cancellationPolicySec-Ja97M {
	text-align: center;
}
.Cancellation-cancelPolicyContent-IE5dN {
	max-width: 307px;
	width: 100%;
	margin-inline: auto;
}
.Cancellation-lineBg-HtX6k {
	background: var(--primary-border);
	margin-top: 22px;
	margin-bottom: 22px;
}
.Cancellation-displayGridDate-aFVjZ {
	display: grid;
	grid-template-columns: 36% 15% 36%;
	gap: 15px;
}
.Cancellation-dateArrowIcon-vwzgK {
	margin-top: -3px;
}
.Cancellation-horizontalLineStyle-KZQIh {
	border-top: 1px solid var(--primary-border);
	margin-top: 24px;
	margin-bottom: 24px;
}
.Cancellation-avatarSpaceRight-VINFK {
	margin-right: 20px;
}
.Cancellation-firstName-TdvfK {
	text-decoration: none;
}
.Cancellation-firstName-TdvfK:hover,
.Cancellation-firstName-TdvfK:focus,
.Cancellation-firstName-TdvfK:active,
.Cancellation-firstName-TdvfK:hover,
.Cancellation-firstName-TdvfK:active:hover {
	text-decoration: underline
}
.Cancellation-cancellationBtnSection-gbYPj {
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
}
.Cancellation-spaceInline-DfIgd {
	margin-inline: 0;
}
.Cancellation-profileLinkPadding-h95o4 {
	padding: 1px !important;
}
.Cancellation-specialPriceText-Xd1fk {
	display: inline-block;
	vertical-align: middle;
}
.Cancellation-specialPriceIcon-jdCvv {
	display: inline-block;
	position: relative;
}
.Cancellation-specialPriceIcon-jdCvv:hover .Cancellation-toolTip-AVJ0l {
	display: block;
}
.Cancellation-toolTip-AVJ0l {
	position: absolute;
	top: -70px;
	right: 0;
	left: 0px;
	display: none;
	background: var(--common-text-color);
	min-width: 280px;
	text-align: center;
	padding: 10px;
	border-radius: 4px;
	color: var(--white-text);
}
.Cancellation-toolTipRelativeSection-s6sWa::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: 10px;
	right: 0;
	top: 60px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-text-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	    -ms-transform: rotate(136deg);
	        transform: rotate(136deg);
}
.Cancellation-faqImage-HYonQ {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin: 0 5px;
}
@media (max-width:1024px) and (min-width:768px) {
	.Cancellation-toolTipRelativeSection-s6sWa::after {
		display: none;
	}

	.Cancellation-toolTip-AVJ0l {
		top: -96px;
		right: auto;
		left: -100px;
		min-width: 227px;
	}
}
@media screen and (max-width:991px) {
	.Cancellation-toolTipRelativeSection-s6sWa::after {
		display: none;
	}

	.Cancellation-toolTip-AVJ0l {
		top: -112px;
		right: auto;
		left: -100px;
		min-width: 227px;
	}

}
@media screen and (max-width:767px) {
	.Cancellation-cancelPolicyContent-IE5dN {
		max-width: 100%;
	}

	.Cancellation-displayGridDate-aFVjZ {
		grid-template-columns: 40% 14% 40%;
		gap: 8px;
	}

	.Cancellation-cancellationBtnSection-gbYPj {
		display: block;
		margin-bottom: 30px;
		text-align: center;
	}

	.Cancellation-mobMarginBtn-H26uG {
		margin-inline: 0 !important;
		margin-bottom: 18px;
	}

	.Cancellation-cancelReservationBtn-BpeUa {
		display: block;
		margin-inline: auto;
	}

	.Cancellation-toolTip-AVJ0l {
		top: -95px;
		min-width: 225px;
		left: -60px;

	}

}
@media screen and (max-width:340px) {
	.Cancellation-toolTip-AVJ0l {
		top: -95px;
		min-width: 172px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/commonStyle.css","webpack://./src/components/Cancellation/Cancellation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;EACE,8CAA8C;EAC9C,kDAAkD;EAClD,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AAEA;;;;;;;EAOE,oDAAoD;EACpD,wDAAwD;EACxD,0CAA0C;EAC1C,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,gDAAgD;EAChD,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;EAC3B,gCAAgC;EAChC,2DAA2D;EAC3D,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;AAEA;;;;;EAKE,gDAAgD;EAChD,wDAAwD;EACxD,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,oDAAoD;EACpD,oDAAoD;EACpD,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;;;;;EAKE,gDAAgD;EAChD,oDAAoD;EACpD,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,2DAA2D;AAC7D;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;AAClD;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;AACb;AAEA;EACE,YAAY;AACd;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;AAEA;;;;;;EAME,+BAA+B;EAC/B,mBAAmB;AACrB;AAEA;;;;;;EAME,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,wDAAgD;UAAhD,gDAAgD;EAChD,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;AACvB;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,QAAQ;EACR,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;EAClB,6CAAqC;UAArC,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,gCAAgC;EAChC,6BAAqB;UAArB,qBAAqB;EACrB,oCAAoC;AACtC;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;AACb;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,kBAAkB;AACpB;AAEA,2DAA2D;AAC3D;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kDAAkD;EAClD,yCAAyC;EACzC,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAgB;OAAhB,gBAAgB;EAChB,mCAAmC;EACnC,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,gCAAgC;AAClC;AAEA,+FAA+F;AAC/F;EACE,kBAAkB;AACpB;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AAEA,6FAA6F;AAC7F,sEAAsE;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;AACf;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;AACtB;AAEA;EACE,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,0BAA0B;AAC5B;AAEA;EACE,gCAAgC;AAClC;AAEA;;;;EAIE,+BAA+B;AACjC;AAEA;EACE,iDAAiD;AACnD;AAEA;;;;EAIE,+BAA+B;AACjC;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;AAEA,kFAAkF;AAClF;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,oBAAoB;AACtB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,YAAY;AACd;AAEA;EACE,oBAAc;MAAd,cAAc;AAChB;AAEA,4FAA4F;AAC5F;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,0CAA0C;AAC5C;AAEA;EACE;AACF;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;AAEA;EACE,WAAW;AACb;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;AAEA;EACE,eAAe;AACjB;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,oCAAoC;EACpC,mBAAmB;AACrB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AAEA,4BAA4B;AAE5B;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,mBAAe;MAAf,eAAe;AACjB;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAe;MAAf,eAAe;EACf,uBAAuB;AACzB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAqB;EACrB,mBAAe;MAAf,eAAe;EACf,uBAAuB;EACvB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,uCAAuC;EACvC,mCAAmC;EACnC,4BAA4B;AAC9B;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;AAEA;;;;;EAKE,qBAAqB;EACrB,+BAA+B;AACjC;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,uBAAe;KAAf,oBAAe;UAAf,eAAe;AACjB;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AAEA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kBAAkB;EAClB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;AACpB;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AAEA;;;;EAIE,+BAA+B;;AAEjC;AAEA;EACE,uBAAe;KAAf,oBAAe;UAAf,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAe;MAAf,eAAe;AACjB;AAEA;EACE,MAAM;AACR;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;AACZ;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,2CAA2C;EAC3C,MAAM;EACN,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,yDAAyD;AAC3D;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AAEA;;;;;;;EAOE,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;AACnC;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,+BAA+B;AACjC;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;AAEA;EACE,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,cAAc;AAChB;AAEA;EACE,uCAAuC;EACvC,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB;AAEA;;;;EAIE,YAAY;EACZ,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;AAC7B;AAEA;EACE,iDAAiD;AACnD;AAEA;EACE,uCAAuC;EACvC,yCAAiC;UAAjC,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;AAEA;;;;EAIE,6BAA6B;EAC7B,YAAY;EACZ,mCAA2B;UAA3B,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;AACvB;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;AAEA;EACE,YAAY;AACd;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;AAEA;EACE,aAAa;AACf;AAEA;EACE,aAAa;AACf;AAEA;EACE,mBAAmB;AACrB;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAe;MAAf,eAAe;AACjB;AAEA;EACE,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,UAAU;EACV,aAAa;EACb,oCAA4B;UAA5B,4BAA4B;EAC5B,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;AACrB;AAEA;;;;EAIE,+BAA+B;EAC/B,iDAAiD;AACnD;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;AACrB;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,gBAAgB;EAChB,2BAA0B;UAA1B,0BAA0B;AAC5B;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AAEA;EACE,QAAQ;AACV;AAEA;EACE,QAAQ;AACV;AAEA;EACE;AACF;AAEA;EACE,SAAS;AACX;AAEA;EACE,SAAS;AACX;AAEA;EACE;AACF;AAEA;EACE,eAAe;AACjB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;AAC1C;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAmB;KAAnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAAuB;KAAvB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;AAEA;EACE,0BAA0B;AAC5B;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;EAC9C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2DAA2D;EAC3D,YAAY;EACZ,OAAO;EACP,QAAQ;AACV;AAGA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,cAAc;AAChB;AAEA;EACE,kBAAkB;EAClB,2BAA0B;UAA1B,0BAA0B;AAC5B;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE;IACE,2BAA2B;IAC3B,wBAAwB;IACxB;EACF;AACF;AAGA;EACE;IACE,iBAAiB;EACnB;AACF;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,mBAAe;QAAf,eAAe;EACjB;;EAEA;IACE,sBAAqB;QAArB,mBAAqB;YAArB,qBAAqB;EACvB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;IACpB,aAAa;EACf;AACF;AAEA;EACE,aAAa;AACf;AAEA;EACE,gDAAgD;AAClD;AAEA;EACE,QAAQ;AACV;AAEA;EACE,QAAQ;AACV;AAEA;EACE,QAAQ;AACV;AAEA;EACE,SAAS;AACX;AAEA;EACE,SAAS;AACX;AAEA;EACE,SAAS;AACX;AAEA;EACE,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;AAClB;AAEA;EACE,aAAa;AACf;AAEA;EACE,2CAA2C;AAC7C;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,0BAAoB;QAApB,uBAAoB;YAApB,oBAAoB;EACtB;AACF;AC1iDA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,mCAAmC;CACnC,kBAAkB;CAClB,0BAA0B;CAC1B,YAAY;CACZ,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;AAEA;CACC,YAAY;AACb;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;;AAEZ;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,0CAA0C;AAC3C;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,iBAAiB;AAClB;AAEA;CACC,uCAAuC;CACvC,gBAAgB;AACjB;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;CACC,MAAM;CACN,kBAAkB;AACnB;AAEA;;;;;;CAMC,+BAA+B;AAChC;AAEA;;;;;CAKC,0BAA0B;AAC3B;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;CACnB,iBAAiB;AAClB;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;AAEA;CACC,yCAAyC;CACzC,6CAA6C;AAC9C;AAEA;CACC,kCAAkC;CAClC,sCAAsC;AACvC;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,sBAAmB;IAAnB,mBAAmB;AACpB;AAEA;CACC,UAAU;AACX;AAEA;CACC,UAAU;AACX;AAEA;CACC,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;AAEA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,SAAS;AACV;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2CAA2C;CAC3C,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,qBAAqB;AACtB;AAEA;;;;;CAKC;AACD;AAEA;CACC,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;AAC1B;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AAEA;CACC,cAAc;AACf;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,aAAa;CACb,oCAAoC;CACpC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,0CAA0C;CAC1C,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;AAC1B;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,aAAa;AACd;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;CACjB;AACD;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;CACjB;;AAED;AAEA;CACC;EACC,eAAe;CAChB;;CAEA;EACC,kCAAkC;EAClC,QAAQ;CACT;;CAEA;EACC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,2BAA2B;EAC3B,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,UAAU;EACV,gBAAgB;EAChB,WAAW;;CAEZ;;AAED;AAEA;CACC;EACC,UAAU;EACV,gBAAgB;CACjB;AACD","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".btnPrimary {\n  border-color: var(--btn-primary-bg) !important;\n  background-color: var(--btn-primary-bg) !important;\n  color: var(--btn-primary-color) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus,\n.btnPrimary[disabled]:hover,\n.btnPrimary[disabled]:focus {\n  border-color: var(--btn-primary-bg-hover) !important;\n  background-color: var(--btn-primary-bg-hover) !important;\n  color: var(--btn-primary-color) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryBorder {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  border-radius: 6px;\n  box-shadow: none !important;\n  text-decoration: none !important;\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n  cursor: pointer;\n  line-height: 24px;\n  display: inline-block;\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n  color: var(--btn-primaryBorder-color) !important;\n  background-color: var(--btn-primaryBorder-bg) !important;\n  box-shadow: none !important;\n}\n\n.btnSecondary {\n  border: 1px solid var(--btn-secondary-bg) !important;\n  background-color: var(--primary-white-bg) !important;\n  color: var(--btn-secondary-bg) !important;\n  padding: 11px 20px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  box-shadow: none !important;\n}\n\n.btnSecondary:hover,\n.btnSecondary:focus,\n.btnSecondary:active,\n.btnSecondary:active:hover,\n.btnSecondary:active:focus {\n  border-color: var(--btn-secondary-bg) !important;\n  background-color: var(--btn-secondary-bg) !important;\n  color: var(--white-text) !important;\n  box-shadow: none !important;\n}\n\n.btnPrimaryLink {\n  border: 1px solid var(--btn-primaryBorder-color) !important;\n}\n\n.nofocus:active:focus {\n  background: var(--primary-white-bg) !important;\n  color: var(--btn-primaryBorder-color) !important;\n}\n\n.btnSmall {\n  padding: 5px 0px;\n}\n\n.btnBig {\n  padding: 12px 21px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.WidthAuto {\n  width: auto;\n}\n\n.fullHeight {\n  height: 100%;\n}\n\n.noTextDecration {\n  text-decoration: none !important;\n}\n\n.commonListStyleNone {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.btnMedium,\n.btnMedium:hover,\n.btnMedium:focus,\n.btnMedium:focus:hover,\n.btnMedium:active,\n.btnMedium:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumSpace,\n.btnMediumSpace:hover,\n.btnMediumSpace:focus,\n.btnMediumSpace:focus:hover,\n.btnMediumSpace:active,\n.btnMediumSpace:active:hover {\n  padding-inline: 19px !important;\n  white-space: normal;\n}\n\n.btnMediumPadding,\n.btnMediumPadding:hover,\n.btnMediumPadding:focus,\n.btnMediumPadding:active,\n.btnMediumPadding:active:hover,\n.btnMediumPadding:focus:hover {\n  padding: 12px 19px;\n}\n\n.aiAskButton {\n  padding: 12px 18px;\n  border: unset !important;\n  outline: unset !important;\n  border-radius: 24px 24px 24px 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--primary-foreground);\n  box-shadow: 0px 2px 6px 0px #EA672021 !important;\n  background: var(--ai-badge-bg) !important;\n  position: relative;\n  opacity: 1 !important;\n}\n\n.aiBadgeStyle {\n  display: inline-flex;\n  gap: 4px;\n  background: var(--ai-badge-bg);\n  border-radius: 100px;\n  position: relative;\n  box-shadow: 0px 2px 6px 0px #EA672021;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 24px;\n  padding: 4px 12px;\n}\n\n.aiTextColor {\n  background: var(--ai-foreground);\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.aiBadgeStyle>svg {\n  position: relative;\n  top: 2px;\n}\n\n.aiAskButton::after,\n.aiBadgeStyle::after {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  background: var(--ai-border);\n  border-radius: inherit;\n  z-index: -1;\n}\n\n.aiFooterInfoText {\n  font-size: 12px;\n  line-height: 18px;\n  color: var(--secondary-foreground);\n  display: inline-block;\n  font-weight: 500;\n}\n\n.regenerateBtn {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 500;\n  display: flex;\n  gap: 4px;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: 0;\n  padding: 0px;\n  align-items: center;\n}\n\n.regenerateBtn>svg {\n  position: relative;\n  top: 3px;\n}\n\n/************************ text Align ************************/\n.textAlignRight {\n  text-align: right;\n}\n\n.textAlignLeft {\n  text-align: left;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n/************************ text Align end ******************/\n.formControlInput {\n  padding: 10px 19px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  line-height: 24px;\n  color: var(--common-text-color);\n  font-weight: normal;\n  border: 1px solid transparent;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.formControlSelect {\n  padding: 10px 35px 10px 19px;\n  height: 48px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--primary-border) !important;\n  background-color: var(--primary-white-bg);\n  color: var(--common-text-color);\n  line-height: 19px;\n  font-weight: normal;\n  display: block;\n  appearance: none;\n  -webkit-appearance: none !important;\n  box-shadow: none !important;\n}\n\n.noTextDecoration {\n  text-decoration: none !important;\n}\n\n/*-----------------------Profilephoto Upload Common Styles Start----------------------------- */\n.picContainerMain {\n  position: relative;\n}\n\n.profilePic {\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n}\n\n.trashIcon {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 22px;\n  height: 22px;\n  background: var(--common-background-color);\n  padding-top: 3px;\n  border: 0;\n  border-radius: 2px;\n  opacity: .9;\n  color: var(--white-text);\n  cursor: pointer;\n}\n\n.trashIconNew {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n}\n\n.trashIconNew img {\n  width: 36px;\n}\n\n.bannerImageBg {\n  width: 100%;\n  height: 100%;\n  min-height: 179px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  position: relative;\n  border-radius: 0px;\n}\n\n.profileImageBg {\n  padding-top: 36%;\n  background-repeat: no-repeat;\n  background-size: contain;\n  width: 100%;\n  height: 100%;\n  max-width: 180px;\n  margin: 0 auto;\n  background-position: 50% 50%;\n  background-size: 66px;\n}\n\n.whiteImg {\n  background: var(--modalText-color);\n  border-radius: 0px;\n}\n\n.curserPointer {\n  cursor: pointer;\n}\n\n.adminLabelTextNew {\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--common-text-color);\n}\n\n/*-----------------------Profilephoto Upload Common Styles End----------------------------- */\n/******************* Admin Modal ListSetting Start *******************/\n.radioBtn {\n  position: relative;\n  top: 1px;\n  vertical-align: middle;\n  margin-left: 3px;\n}\n\n.displayinlineBlock {\n  display: inline-block;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.inlineDisplayFlex {\n  display: inline-flex;\n}\n\n.alignCenter {\n  align-items: center;\n}\n\n.spaceBetween {\n  justify-content: space-between;\n}\n\n.alignItemFlexStart {\n  align-items: flex-start;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n.commonTitleText {\n  font-size: 36px;\n  margin: 0px;\n  word-wrap: break-word;\n}\n\n.commonSubTitleText {\n  font-size: 20px;\n  margin: 0px;\n}\n\n.commonContentText {\n  font-size: 18px;\n  margin: 0px;\n}\n\n.commonMediumText {\n  font-size: 16px;\n  margin: 0px;\n}\n\n.commonTotalText {\n  font-size: 24px;\n  margin: 0px;\n}\n\n.commonSmallText {\n  font-size: 14px;\n  margin: 0px;\n}\n\n.fontWeightExtraBold {\n  font-weight: 700;\n}\n\n.fontWeightBold {\n  font-weight: 600;\n}\n\n.fontWeightMedium {\n  font-weight: 500;\n}\n\n.fontWeightNormal {\n  font-weight: 400;\n}\n\n.textDecorationUnderLine {\n  text-decoration: underline;\n}\n\n.textDecorationNone {\n  text-decoration: none !important;\n}\n\n.siteLinkColor,\n.siteLinkColor:hover,\n.siteLinkColor:focus,\n.siteLinkColor:active {\n  color: var(--common-link-color);\n}\n\n.commonLinkBorderBottom {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.siteTextColor,\n.siteTextColor:hover,\n.siteTextColor:focus,\n.siteTextColor:active {\n  color: var(--common-text-color);\n}\n\n.positionRelative {\n  position: relative;\n}\n\n.listingHorizoltalLine {\n  margin: 40px 0px;\n  border-top: 1px solid var(--primary-border);\n}\n\n/******************************* Common Margin Start *****************************/\n.spaceBottom0 {\n  margin-bottom: 0px;\n}\n\n.spaceBottom1 {\n  margin-bottom: 6px;\n}\n\n.spaceBottom2 {\n  margin-bottom: 12px;\n}\n\n.spaceBottom3 {\n  margin-bottom: 18px;\n}\n\n.spaceBottom4 {\n  margin-bottom: 24px;\n}\n\n.spaceBottom5 {\n  margin-bottom: 30px;\n}\n\n.spaceBottom6 {\n  margin-bottom: 36px;\n}\n\n.spaceBottom7 {\n  margin-bottom: 42px;\n}\n\n.spaceBottom8 {\n  margin-bottom: 10px;\n}\n\n.spaceTop0 {\n  margin-top: 0px;\n}\n\n.spaceTop1 {\n  margin-top: 6px;\n}\n\n.spaceTop2 {\n  margin-top: 12px;\n}\n\n.spaceTop3 {\n  margin-top: 18px;\n}\n\n.spaceTop4 {\n  margin-top: 24px;\n}\n\n.spaceTop5 {\n  margin-top: 30px;\n}\n\n.spaceTop6 {\n  margin-top: 36px;\n}\n\n.spaceTop7 {\n  margin-top: 42px;\n}\n\n.paddingBottom1 {\n  padding-bottom: 6px;\n}\n\n.paddingBottom2 {\n  padding-bottom: 12px;\n}\n\n.paddingBottom3 {\n  padding-bottom: 18px;\n}\n\n.paddingBottom4 {\n  padding-bottom: 24px;\n}\n\n.paddingBottom5 {\n  padding-bottom: 30px;\n}\n\n.paddingBottom6 {\n  padding-bottom: 36px;\n}\n\n.paddingBottom7 {\n  padding-bottom: 42px;\n}\n\n.paddingTop1 {\n  padding-top: 6px;\n}\n\n.paddingTop2 {\n  padding-top: 12px;\n}\n\n.paddingTop3 {\n  padding-top: 18px;\n}\n\n.paddingTop4 {\n  padding-top: 24px;\n}\n\n.paddingTop5 {\n  padding-top: 30px;\n}\n\n.paddingTop6 {\n  padding-top: 36px;\n}\n\n.paddingTop7 {\n  padding-top: 42px;\n}\n\n.spaceRight1 {\n  margin-right: 6px;\n}\n\n.spaceRight2 {\n  margin-right: 12px;\n}\n\n.spaceRight3 {\n  margin-right: 18px;\n}\n\n.spaceRight4 {\n  margin-right: 24px;\n}\n\n.paddingBottom8 {\n  padding-bottom: 15px;\n}\n\n.spaceTop8 {\n  margin-top: 16px;\n}\n\n.paddingBottomNone {\n  padding-bottom: 0;\n}\n\n.spaceBottom9 {\n  margin-bottom: 16px;\n}\n\n.spaceBottom10 {\n  margin-bottom: 17px;\n}\n\n.spaceBottom11 {\n  margin-bottom: 7px;\n}\n\n.spaceBottom12 {\n  margin-bottom: 20px;\n}\n\n.noPadding {\n  padding: 0px;\n}\n\n.flexShrinkNone {\n  flex-shrink: 0;\n}\n\n/******************************* Common Margin And Padding End *****************************/\n.viewListIcon {\n  width: 100%;\n  max-width: 35px;\n  min-width: 35px;\n}\n\n.blueLeftArrow {\n  padding-left: 6px;\n  position: relative;\n}\n\n.profileAvatarLink {\n  border: 2.5px solid var(--common-link-color);\n  border-radius: 50%;\n  display: inline-block;\n  padding: 7px;\n  background-color: var(--dashBoard-info-bg);\n}\n\n.profileAvatarLinkSmall {\n  padding: 2px\n}\n\n.errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}\n\n.textTransformLowerCase {\n  text-transform: lowercase;\n}\n\n.passwordIcon {\n  position: absolute;\n  right: 18px;\n  top: 43px;\n  cursor: pointer;\n}\n\n.noMargin {\n  margin: 0px;\n}\n\n.noMarginBottom {\n  margin-bottom: 0 !important;\n}\n\n.dotCss {\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  margin: 0px 4px;\n  display: inline-block;\n  position: relative;\n  top: -3px;\n}\n\n.dateArrowMargin {\n  margin: 0px 8px;\n}\n\n.commonBorderSection {\n  --wrapper-Padding: 24px;\n  border: 1px solid var(--primary-border);\n  padding: 18px var(--wrapper-Padding);\n  border-radius: 12px;\n}\n\n.vtrMiddle {\n  vertical-align: middle;\n}\n\n.positionAvatar {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n/* display flex properties */\n\n.dFlex {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n}\n\n.flexWrap {\n  flex-wrap: wrap;\n}\n\n.dInlineFlex {\n  display: inline-block;\n  display: -webkit-inline-box;\n  align-items: center;\n}\n\n.dFlexContainer {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dFlexWrap {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n}\n\n.dFlexWrapAlignEnd {\n  display: flex;\n  display: -webkit-flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.dFlexWrapAlignStart {\n  display: flex;\n  display: -webkit-flex;\n  flex-wrap: wrap;\n  -webkit-flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.justifyContentSpaceBetween {\n  justify-content: space-between;\n}\n\n.greyText {\n  color: var(--modalText-color);\n}\n\n.tripsReservationPanel {\n  border-radius: 12px;\n  width: 100%;\n  display: block;\n  border: 1px solid var(--primary-border);\n  background: var(--primary-white-bg);\n  padding: 15px 24px 24px 24px;\n}\n\n.listContainer {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.listTabItem {\n  display: block;\n  padding: 0px 0px 7px;\n  position: relative;\n  text-align: center;\n  font-size: 18px;\n  color: var(--modalText-color);\n  cursor: pointer;\n  border-bottom: 1px solid transparent;\n  margin-right: 30px;\n}\n\n.listTabItem:hover,\n.listTabItem:active,\n.listTabItem:focus,\n.listTabItem:active:hover,\n.listTabItem:focus:hover {\n  text-decoration: none;\n  color: var(--common-text-color);\n}\n\n.reviewsContainer {\n  display: flex;\n  align-items: flex-start;\n  column-gap: 6px;\n}\n\n.reviewsYourItemsOne {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n}\n\n.reviewsYourItemsTwo {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 100%;\n  flex: 1 1 100%;\n}\n\n.rightBg {\n  background: var(--common-gray-bg-color);\n  border-radius: 0 8px 8px 8px;\n  padding: 16px 18px 18px 18px;\n  width: 100%;\n  position: relative;\n  -webkit-border-radius: 0 8px 8px 8px;\n  -moz-border-radius: 0 8px 8px 8px;\n  -ms-border-radius: 0 8px 8px 8px;\n  -o-border-radius: 0 8px 8px 8px;\n}\n\n.commonProfileAvatarLink {\n  backface-visibility: hidden;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  width: 68px;\n  height: 68px;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 2px solid var(--common-link-color);\n  background-color: transparent;\n  padding: 3px;\n  position: relative;\n  z-index: 5;\n}\n\n.commonProfileAvatarLink img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: var(--primary-white-bg);\n  border-radius: 50%;\n}\n\n.writtenReviewTitle {\n  font-weight: 500;\n  margin-bottom: 6px;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.reviewTitleLink {\n  color: var(--common-link-color);\n  font-weight: 500;\n}\n\n.reviewTitleLink:hover,\n.reviewTitleLink:focus,\n.reviewTitleLink:active,\n.reviewTitleLink:active:hover {\n  color: var(--common-link-color);\n\n}\n\n.reviewFlex {\n  column-gap: 5px;\n  font-size: 14px;\n  color: var(--common-text-color);\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.noTop {\n  top: 0;\n}\n\n.reviewPara {\n  color: var(--common-text-color);\n  word-break: break-word;\n}\n\n.dFlexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.commonlineCss {\n  margin: 18px 0;\n  border: 1px solid var(--primary-border);\n}\n\n.rightBg::after {\n  content: \"\";\n  position: absolute;\n  left: -38px;\n  top: 0;\n  right: auto;\n  width: 38px;\n  height: 40px;\n  background: var(--primary-white-bg);\n  border-top-right-radius: 30px;\n  border-bottom-left-radius: 30px;\n  z-index: 3;\n}\n\n.rightBg::before {\n  content: \" \";\n  position: absolute;\n  display: inline-block;\n  width: 0;\n  height: 0;\n  bottom: auto;\n  border: 10px solid transparent;\n  border-left: 0;\n  border-right-color: var(--primary-white-bg);\n  top: 0;\n  left: auto;\n  right: 100%;\n  border-width: 0 24px 24px 0;\n  border-color: transparent #F9F9F9 transparent transparent;\n}\n\n.loadBtn {\n  border-color: var(--btn-primary-bg);\n  color: var(--white-text);\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  background: var(--btn-primary-bg);\n  border-radius: 6px;\n  padding: 12px 19px;\n  font-size: 18px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.loadBtn:hover,\n.loadBtn:active,\n.loadBtn:focus,\n.loadBtn:active:hover,\n.loadBtn:active:focus,\n.loadBtn[disabled]:hover,\n.loadBtn[disabled]:focus {\n  color: var(--white-text);\n  border-color: var(--btn-primary-bg);\n  background: var(--btn-primary-bg);\n}\n\n.vtrTop {\n  vertical-align: top;\n}\n\n.reviewHeadingColor {\n  color: var(--common-text-color);\n}\n\n.reviewWriteHeading {\n  font-weight: 500;\n  word-break: break-word;\n  color: var(--common-text-color);\n  font-size: 18px;\n}\n\n.noDataImgSize {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.justifyCenter {\n  justify-content: center;\n}\n\n.btnTextBrk {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.marginInlineAuto {\n  margin-inline: auto;\n}\n\n.noItemPanel {\n  background: var(--primary-white-bg);\n  border-radius: 12px;\n  border: 1px solid var(--primary-border);\n  padding: 44px 0;\n}\n\n.textLineBreak {\n  word-break: break-word;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayInlineBlock {\n  display: inline-block;\n}\n\n.commonContainerList {\n  width: 100%;\n  max-width: var(--max-listing-width);\n  margin: 0 auto;\n}\n\n.adminBorderWithoutPadding {\n  border: 1px solid var(--primary-border);\n  border-radius: 4px;\n}\n\n.marginRight8 {\n  margin-right: 8px;\n}\n\n.adminDotIconBtn,\n.adminDotIconBtn:hover,\n.adminDotIconBtn:focus,\n.adminDotIconBtn:active {\n  border: none;\n  background-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.commonLinkBorder {\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.commonTabelDropDownBg {\n  background: var(--common-gray-bg-color);\n  box-shadow: 0px 3px 6px #00000029;\n  border-radius: 6px;\n  padding: 10px;\n}\n\n.tabelDropDownBtn,\n.tabelDropDownBtn:hover,\n.tabelDropDownBtn:active,\n.tabelDropDownBtn:focus {\n  padding: 12px 10px !important;\n  border: none;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  font-size: 16px;\n  color: var(--common-text-color);\n  line-height: inherit;\n  vertical-align: top;\n  border-radius: 0;\n}\n\n.tableHorizantalLine {\n  border-color: var(--primary-border);\n  margin: 6px 0px;\n}\n\n.backArrowStyle {\n  width: 15px;\n  height: 12px;\n  margin-right: 6px;\n}\n\n.csvImageSpace {\n  margin: 0px 6px;\n}\n\n.flexEnd {\n  align-items: flex-end;\n}\n\n.justifyContentFlexEnd {\n  justify-content: flex-end;\n}\n\n.profileAvatarLinkPayment {\n  padding: 5px;\n}\n\n.alignItemBaseline {\n  align-items: baseline;\n}\n\n.payOutToolTip {\n  margin: 0 3px;\n}\n\n.tolltipMargin {\n  margin: 0 3px;\n}\n\n.textNoWrap {\n  white-space: nowrap;\n}\n\n\n.commonSearchInputFilterContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-grow: 1;\n}\n\n.mobileTableSearch {\n  margin-bottom: 24px;\n  gap: 16px;\n  grid-gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mobileTableOnlyLink {\n  justify-content: flex-end;\n}\n\n.linkBtnPrimaryStyle {\n  background-color: transparent !important;\n  color: var(--common-link-color);\n  padding: 0;\n  border: unset;\n  box-shadow: unset !important;\n  border-bottom: 1px solid var(--common-link-color);\n  font-weight: 500;\n  font-size: 18px;\n  text-decoration: none;\n  line-height: 26px;\n  border-radius: 0 !important;\n  white-space: normal;\n}\n\n.linkBtnPrimaryStyle:hover,\n.linkBtnPrimaryStyle:focus,\n.linkBtnPrimaryStyle:active,\n.linkBtnPrimaryStyle:active:hover {\n  color: var(--common-link-color);\n  border-bottom: 1px solid var(--common-link-color);\n}\n\n.dataTableGrid {\n  display: grid;\n  grid-template-columns: 3fr 2fr;\n  gap: 4px;\n}\n\n.paymentDivider {\n  border-bottom: 1px solid var(--primary-border);\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n}\n\n.paymentDivider:last-child {\n  border-bottom: unset;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.bulletList {\n  list-style: disc;\n  padding-inline-start: 25px;\n}\n\n.commonSmallText14 {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.commonSmallText16 {\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.commonSmallText18 {\n  font-size: 18px;\n  line-height: 24px;\n}\n\n.commonSmallText20 {\n  font-size: 20px;\n  line-height: 26px;\n}\n\n.commonSmallText24 {\n  font-size: 24px;\n  line-height: 30px;\n}\n\n.commonSmallText26 {\n  font-size: 26px;\n  line-height: normal;\n}\n\n.top1 {\n  top: 1px;\n}\n\n.top2 {\n  top: 2px;\n}\n\n.top3 {\n  top: 3px\n}\n\n.topMinus1 {\n  top: -1px;\n}\n\n.topMinus2 {\n  top: -2px;\n}\n\n.topMinus3 {\n  top: -3px\n}\n\n.textEnd {\n  text-align: end;\n}\n\n.textAlignCenter {\n  text-align: center;\n}\n\n.textStart {\n  text-align: start;\n}\n\n.flexGrow {\n  flex-grow: 1;\n}\n\n/* dropzone */\n.imageUploadDropzoneSection {\n  border-radius: 12px;\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n\n.imageUploadDropzoneSectionOutline {\n  background-color: var(--secondary-gray-bg);\n  border: 2px dashed var(--primary-border);\n}\n\n.commonDropZoneImgContainer {\n  position: absolute;\n  inset: 0;\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n  background-repeat: no-repeat;\n  object-position: center;\n  background-size: contain;\n  background-position: center;\n}\n\n.commonDropZoneDefaultImg {\n  background-size: 70px 70px;\n}\n\n.navTabFlex {\n  display: flex;\n  align-items: center;\n  gap: 12px 30px;\n  border-bottom: 1px solid var(--primary-border);\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n}\n\n.navTabLink {\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--tertiary-foreground) !important;\n  padding-bottom: 6px;\n  text-decoration: none !important;\n  position: relative;\n  text-align: center;\n  display: block;\n  cursor: pointer;\n}\n\n.navTabLink.activeTabStyle {\n  color: var(--primary-foreground) !important;\n  font-weight: 500;\n}\n\n.navTabLink.activeTabStyle::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  background-color: var(--primary-link-foreground) !important;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n}\n\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer {\n  display: flex;\n  font-size: 14px;\n  color: var(--primary-foreground);\n  align-items: center;\n}\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer>div {\n  max-width: 50%;\n}\n\n.transmissionLabelText {\n  position: relative;\n  padding-inline-start: 15px;\n}\n\n.transmissionLabelText::before {\n  content: '';\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background: var(--common-background-color);\n  border-radius: 50%;\n  left: 5px;\n  top: 8px;\n}\n\n.carTypeIcon {\n  position: relative;\n  top: -2px;\n}\n\n.textFlow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@media screen and (min-width:992px) {\n  .paymentSticky {\n    position: sticky !important;\n    position: -webkit-sticky;\n    top: 42px\n  }\n}\n\n\n@media (max-width: 1024px) and (min-width: 768px) {\n  .dateArrowMargin {\n    margin: 0px -10px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .btnWidth {\n    width: 100%;\n  }\n\n  .mobTextCenter {\n    text-align: center !important;\n  }\n\n  .tripsReservationPanel {\n    padding-inline: 15px;\n  }\n\n  .listContainer {\n    border-bottom: unset;\n    flex-wrap: wrap;\n  }\n\n  .listContainer li .listTabItem {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .writtenReviewTitle,\n  .reviewTitleLink {\n    font-size: 16px;\n  }\n\n  .reviewFlex {\n    font-size: 12px;\n  }\n\n  .reviewPara {\n    font-size: 14px;\n  }\n\n  .commonProfileAvatarLink {\n    width: 50px;\n    height: 50px;\n  }\n\n  .reviewWriteHeading {\n    font-size: 16px;\n  }\n\n  .mobileReviewIconBox {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .mrMarginBottom {\n    margin-bottom: 5px;\n  }\n\n  .mrRemoveMargin {\n    margin-right: 0;\n  }\n\n  .mrListDeletBtnBox {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer {\n    flex-direction: column;\n  }\n\n  .mobileFlexContainer li {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .mobileDisplayBlock {\n    display: block;\n  }\n\n  .mobileTextCenter {\n    text-align: center;\n  }\n\n  .profileImageBg,\n  .bannerImageBg {\n    padding-top: 60%;\n  }\n\n  .trashIconNew {\n    top: 12px;\n    right: 12px;\n  }\n\n  .mobileTableSearch {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .commonBorderSection {\n    --wrapper-Padding: 18px;\n  }\n\n  .commonSearchInputFilterContainer {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .mobileTableOnlyLink {\n    align-items: flex-end;\n  }\n\n  .navTabFlex {\n    flex-direction: column;\n    align-items: stretch;\n    border: unset;\n  }\n}\n\n.displayGrid {\n  display: grid;\n}\n\n.gridCols2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.gap4 {\n  gap: 4px;\n}\n\n.gap6 {\n  gap: 6px;\n}\n\n.gap8 {\n  gap: 8px;\n}\n\n.gap12 {\n  gap: 12px;\n}\n\n.gap16 {\n  gap: 16px;\n}\n\n.gap24 {\n  gap: 24px;\n}\n\n.columnGap16 {\n  column-gap: 16px;\n}\n\n.rowGap18 {\n  row-gap: 18px;\n}\n\n.bt {\n  border-top: 1px solid var(--primary-border);\n}\n\n.languageBox>div:not(:first-child) {\n  padding-top: 24px;\n  border-top: 1px solid var(--primary-border);\n  margin-top: 24px;\n}\n\n.languageBtnContainerOne {\n  margin-bottom: 24px;\n}\n\n.languageBox>div:last-child .languageBtnContainerOne {\n  margin-bottom: 0;\n}\n\n.commonInputGrpDivider {\n  padding-bottom: 18px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n@media screen and (max-width: 991px) {\n  .gridColsTab1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .gapTab0 {\n    gap: 0px !important;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .gridColsMobile1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .mobileFlexColumn {\n    flex-direction: column;\n  }\n\n  .mobileAlignFlexStretch {\n    align-items: stretch;\n  }\n}","@import '../../components/utils.css';\n@import '../../components/commonStyle.css';\n\n\n.Cancel-container-1VRb7 {\n\tmargin: 0px auto;\n\tmax-width: 1080px;\n}\n\n.textAreaInput {\n\theight: 187px !important;\n\tpadding: 14px 19px;\n\tborder-color: var(--primary-border);\n\tborder-radius: 6px;\n\tfont-size: 16px !important;\n\tresize: none;\n\tbox-shadow: none;\n}\n\n.textTruncate {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.profileAvatarSection {\n\tposition: absolute;\n\ttop: 11px;\n\tright: 12px;\n\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--common-link-color);\n}\n\n.textRight {\n\ttext-align: right;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.cancelBg {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tborder-radius: 6px;\n}\n\n.bgCover {\n\twidth: 100%;\n\theight: 199px;\n\tposition: relative;\n\tborder-radius: 6px;\n}\n\n.profileAvatar {\n\tbackground: transparent;\n\tborder-radius: 50%;\n}\n\n.carTypeTextSec {\n\twidth: 100%;\n\tmargin-bottom: 8px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.steeringIcon {\n\twidth: 14px;\n\theight: 14px;\n\tobject-fit: contain;\n\tmargin-right: 3px;\n}\n\n.cancelRightCol {\n\tbackground: var(--common-gray-bg-color);\n\tmargin-top: 10px;\n}\n\n.carType {\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.dotStyle {\n\ttop: 0;\n\tmargin-inline: 4px;\n}\n\n.listingTitle,\n.listingTitle:hover,\n.listingTitle:focus,\n.listingTitle:active,\n.listingTitle:active:hover,\n.listingTitle:focus:hover {\n\tcolor: var(--common-text-color);\n}\n\n.listingTitle:hover,\n.listingTitle:focus,\n.listingTitle:active,\n.listingTitle:active:hover,\n.listingTitle:focus:hover {\n\ttext-decoration: underline;\n}\n\n.listingTitleSec {\n\tmargin-bottom: 7px;\n}\n\n.starIcon {\n\twidth: 14px;\n\theight: 14px;\n\tobject-fit: contain;\n\tmargin-right: 3px;\n}\n\n.cancelPayDetails {\n\tpadding: 24px;\n\tborder-radius: 12px;\n}\n\n.guestFundSec {\n\tbackground-color: var(--cancel-refund-bg);\n\tborder: 1px solid var(--cancel-refund-border);\n}\n\n.hostFundSec {\n\tbackground-color: var(--cancel-bg);\n\tborder: 1px solid var(--cancel-border);\n}\n\n.missedEarningsIcon {\n\twidth: 22px;\n\theight: 22px;\n\tmargin-right: 8px;\n\tobject-fit: contain;\n}\n\n.rightSecWidth {\n\twidth: 45%;\n}\n\n.leftSecWidth {\n\twidth: 55%;\n}\n\n.strikeOutLine {\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--strike-line);\n}\n\n.cancellationPolicySec {\n\ttext-align: center;\n}\n\n.cancelPolicyContent {\n\tmax-width: 307px;\n\twidth: 100%;\n\tmargin-inline: auto;\n}\n\n.lineBg {\n\tbackground: var(--primary-border);\n\tmargin-top: 22px;\n\tmargin-bottom: 22px;\n}\n\n.displayGridDate {\n\tdisplay: grid;\n\tgrid-template-columns: 36% 15% 36%;\n\tgap: 15px;\n}\n\n.dateArrowIcon {\n\tmargin-top: -3px;\n}\n\n.horizontalLineStyle {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-top: 24px;\n\tmargin-bottom: 24px;\n}\n\n.avatarSpaceRight {\n\tmargin-right: 20px;\n}\n\n.firstName {\n\ttext-decoration: none;\n}\n\n.firstName:hover,\n.firstName:focus,\n.firstName:active,\n.firstName:hover,\n.firstName:active:hover {\n\ttext-decoration: underline\n}\n\n.cancellationBtnSection {\n\tjustify-content: flex-end;\n}\n\n.spaceInline {\n\tmargin-inline: 0;\n}\n\n.profileLinkPadding {\n\tpadding: 1px !important;\n}\n\n.specialPriceText {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n\n.specialPriceIcon {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -70px;\n\tright: 0;\n\tleft: 0px;\n\tdisplay: none;\n\tbackground: var(--common-text-color);\n\tmin-width: 280px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcolor: var(--white-text);\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 10px;\n\tright: 0;\n\ttop: 60px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-text-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\ttransform: rotate(136deg);\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin: 0 5px;\n}\n\n@media (max-width:1024px) and (min-width:768px) {\n\t.toolTipRelativeSection::after {\n\t\tdisplay: none;\n\t}\n\n\t.toolTip {\n\t\ttop: -96px;\n\t\tright: auto;\n\t\tleft: -100px;\n\t\tmin-width: 227px;\n\t}\n}\n\n@media screen and (max-width:991px) {\n\t.toolTipRelativeSection::after {\n\t\tdisplay: none;\n\t}\n\n\t.toolTip {\n\t\ttop: -112px;\n\t\tright: auto;\n\t\tleft: -100px;\n\t\tmin-width: 227px;\n\t}\n\n}\n\n@media screen and (max-width:767px) {\n\t.cancelPolicyContent {\n\t\tmax-width: 100%;\n\t}\n\n\t.displayGridDate {\n\t\tgrid-template-columns: 40% 14% 40%;\n\t\tgap: 8px;\n\t}\n\n\t.cancellationBtnSection {\n\t\tdisplay: block;\n\t\tmargin-bottom: 30px;\n\t\ttext-align: center;\n\t}\n\n\t.mobMarginBtn {\n\t\tmargin-inline: 0 !important;\n\t\tmargin-bottom: 18px;\n\t}\n\n\t.cancelReservationBtn {\n\t\tdisplay: block;\n\t\tmargin-inline: auto;\n\t}\n\n\t.toolTip {\n\t\ttop: -95px;\n\t\tmin-width: 225px;\n\t\tleft: -60px;\n\n\t}\n\n}\n\n@media screen and (max-width:340px) {\n\t.toolTip {\n\t\ttop: -95px;\n\t\tmin-width: 172px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Cancellation-errorMessage-EqisI`,
	"btnPrimary": `Cancellation-btnPrimary-p5ky4`,
	"btnPrimaryBorder": `Cancellation-btnPrimaryBorder-T8RsP`,
	"btnSecondary": `Cancellation-btnSecondary-ikOEJ`,
	"btnPrimaryLink": `Cancellation-btnPrimaryLink-kXcbf`,
	"nofocus": `Cancellation-nofocus-tcyQU`,
	"btnSmall": `Cancellation-btnSmall-Bd81y`,
	"btnBig": `Cancellation-btnBig-gPd0y`,
	"fullWidth": `Cancellation-fullWidth-R0Zb6`,
	"WidthAuto": `Cancellation-WidthAuto-T1j5_`,
	"fullHeight": `Cancellation-fullHeight-WMc7i`,
	"noTextDecration": `Cancellation-noTextDecration-npHG1`,
	"commonListStyleNone": `Cancellation-commonListStyleNone-M2rEG`,
	"btnMedium": `Cancellation-btnMedium-Qoppw`,
	"btnMediumSpace": `Cancellation-btnMediumSpace-IBiqC`,
	"btnMediumPadding": `Cancellation-btnMediumPadding-ajNAo`,
	"aiAskButton": `Cancellation-aiAskButton-H2EJd`,
	"aiBadgeStyle": `Cancellation-aiBadgeStyle-F2EIW`,
	"aiTextColor": `Cancellation-aiTextColor-Hgywz`,
	"aiFooterInfoText": `Cancellation-aiFooterInfoText-_NOX4`,
	"regenerateBtn": `Cancellation-regenerateBtn-dSJau`,
	"textAlignRight": `Cancellation-textAlignRight-DacN1`,
	"textAlignLeft": `Cancellation-textAlignLeft-okzAh`,
	"textAlignCenter": `Cancellation-textAlignCenter-bxLnm`,
	"formControlInput": `Cancellation-formControlInput-kp2nJ`,
	"formControlSelect": `Cancellation-formControlSelect-cRO70`,
	"noTextDecoration": `Cancellation-noTextDecoration-YYJR9`,
	"picContainerMain": `Cancellation-picContainerMain-PYdP_`,
	"profilePic": `Cancellation-profilePic-vOKRQ`,
	"trashIcon": `Cancellation-trashIcon-G2qDW`,
	"trashIconNew": `Cancellation-trashIconNew-ZLfyd`,
	"bannerImageBg": `Cancellation-bannerImageBg-VVjBm`,
	"profileImageBg": `Cancellation-profileImageBg-qb4B1`,
	"whiteImg": `Cancellation-whiteImg-VqYMg`,
	"curserPointer": `Cancellation-curserPointer-Vbcj8`,
	"adminLabelTextNew": `Cancellation-adminLabelTextNew-N1WG4`,
	"radioBtn": `Cancellation-radioBtn-ak8w6`,
	"displayinlineBlock": `Cancellation-displayinlineBlock-F69cd`,
	"displayBlock": `Cancellation-displayBlock-qDaOO`,
	"displayFlex": `Cancellation-displayFlex-W4MK9`,
	"inlineDisplayFlex": `Cancellation-inlineDisplayFlex-RYrl6`,
	"alignCenter": `Cancellation-alignCenter-GBb0Y`,
	"spaceBetween": `Cancellation-spaceBetween-A4tPs`,
	"alignItemFlexStart": `Cancellation-alignItemFlexStart-utKE6`,
	"commonTitleText": `Cancellation-commonTitleText-yjoNl`,
	"commonSubTitleText": `Cancellation-commonSubTitleText-ANPD1`,
	"commonContentText": `Cancellation-commonContentText-VGV6J`,
	"commonMediumText": `Cancellation-commonMediumText-Cz0Ps`,
	"commonTotalText": `Cancellation-commonTotalText-Nz6GT`,
	"commonSmallText": `Cancellation-commonSmallText-rsW33`,
	"fontWeightExtraBold": `Cancellation-fontWeightExtraBold-ypLiV`,
	"fontWeightBold": `Cancellation-fontWeightBold-iOLrS`,
	"fontWeightMedium": `Cancellation-fontWeightMedium-goj0m`,
	"fontWeightNormal": `Cancellation-fontWeightNormal-cx6yv`,
	"textDecorationUnderLine": `Cancellation-textDecorationUnderLine-XlfOr`,
	"textDecorationNone": `Cancellation-textDecorationNone-h4Ypz`,
	"siteLinkColor": `Cancellation-siteLinkColor-Y1zbY`,
	"commonLinkBorderBottom": `Cancellation-commonLinkBorderBottom-d0M20`,
	"siteTextColor": `Cancellation-siteTextColor-Hk8hq`,
	"positionRelative": `Cancellation-positionRelative-_QI_2`,
	"listingHorizoltalLine": `Cancellation-listingHorizoltalLine-Jmcb2`,
	"spaceBottom0": `Cancellation-spaceBottom0-p0751`,
	"spaceBottom1": `Cancellation-spaceBottom1-uoAAK`,
	"spaceBottom2": `Cancellation-spaceBottom2-TjOb5`,
	"spaceBottom3": `Cancellation-spaceBottom3-kuoaw`,
	"spaceBottom4": `Cancellation-spaceBottom4-opsn1`,
	"spaceBottom5": `Cancellation-spaceBottom5-Y8NCb`,
	"spaceBottom6": `Cancellation-spaceBottom6-QdSCY`,
	"spaceBottom7": `Cancellation-spaceBottom7-nLb9d`,
	"spaceBottom8": `Cancellation-spaceBottom8-gKmvQ`,
	"spaceTop0": `Cancellation-spaceTop0-vs9jj`,
	"spaceTop1": `Cancellation-spaceTop1-UkWSE`,
	"spaceTop2": `Cancellation-spaceTop2-i9Xtj`,
	"spaceTop3": `Cancellation-spaceTop3-gcMRt`,
	"spaceTop4": `Cancellation-spaceTop4-r5dPf`,
	"spaceTop5": `Cancellation-spaceTop5-uXGr0`,
	"spaceTop6": `Cancellation-spaceTop6-rF17q`,
	"spaceTop7": `Cancellation-spaceTop7-TPtJI`,
	"paddingBottom1": `Cancellation-paddingBottom1-JcDeX`,
	"paddingBottom2": `Cancellation-paddingBottom2-TZWcR`,
	"paddingBottom3": `Cancellation-paddingBottom3-k_iPl`,
	"paddingBottom4": `Cancellation-paddingBottom4-tcwRV`,
	"paddingBottom5": `Cancellation-paddingBottom5-yyhXi`,
	"paddingBottom6": `Cancellation-paddingBottom6-HEvlt`,
	"paddingBottom7": `Cancellation-paddingBottom7-sxsru`,
	"paddingTop1": `Cancellation-paddingTop1-cGnA8`,
	"paddingTop2": `Cancellation-paddingTop2-_iMaz`,
	"paddingTop3": `Cancellation-paddingTop3-HIEsv`,
	"paddingTop4": `Cancellation-paddingTop4-SBgoz`,
	"paddingTop5": `Cancellation-paddingTop5-dAkgV`,
	"paddingTop6": `Cancellation-paddingTop6-RFUit`,
	"paddingTop7": `Cancellation-paddingTop7-YVVFK`,
	"spaceRight1": `Cancellation-spaceRight1-u44LZ`,
	"spaceRight2": `Cancellation-spaceRight2-C9TcS`,
	"spaceRight3": `Cancellation-spaceRight3-xWbyO`,
	"spaceRight4": `Cancellation-spaceRight4-JTpES`,
	"paddingBottom8": `Cancellation-paddingBottom8-zf6Pe`,
	"spaceTop8": `Cancellation-spaceTop8-wsbTm`,
	"paddingBottomNone": `Cancellation-paddingBottomNone-Aw7Ud`,
	"spaceBottom9": `Cancellation-spaceBottom9-PntH4`,
	"spaceBottom10": `Cancellation-spaceBottom10-H33VV`,
	"spaceBottom11": `Cancellation-spaceBottom11-MYzSj`,
	"spaceBottom12": `Cancellation-spaceBottom12-ymoNA`,
	"noPadding": `Cancellation-noPadding-Ca26q`,
	"flexShrinkNone": `Cancellation-flexShrinkNone-d46rz`,
	"viewListIcon": `Cancellation-viewListIcon-aAhiq`,
	"blueLeftArrow": `Cancellation-blueLeftArrow-knj33`,
	"profileAvatarLink": `Cancellation-profileAvatarLink-putbE`,
	"profileAvatarLinkSmall": `Cancellation-profileAvatarLinkSmall-k3N3d`,
	"textTransformLowerCase": `Cancellation-textTransformLowerCase-VXWrE`,
	"passwordIcon": `Cancellation-passwordIcon-SeuEJ`,
	"noMargin": `Cancellation-noMargin-efhhi`,
	"noMarginBottom": `Cancellation-noMarginBottom-TUgt4`,
	"dotCss": `Cancellation-dotCss-O4AmJ`,
	"dateArrowMargin": `Cancellation-dateArrowMargin-RWE2W`,
	"commonBorderSection": `Cancellation-commonBorderSection-mOaty`,
	"vtrMiddle": `Cancellation-vtrMiddle-v62uE`,
	"positionAvatar": `Cancellation-positionAvatar-_R4Yy`,
	"dFlex": `Cancellation-dFlex-LkZ73`,
	"flexWrap": `Cancellation-flexWrap-resjy`,
	"dInlineFlex": `Cancellation-dInlineFlex-arF3q`,
	"dFlexContainer": `Cancellation-dFlexContainer-nMhED`,
	"dFlexWrap": `Cancellation-dFlexWrap-HXHwA`,
	"dFlexWrapAlignEnd": `Cancellation-dFlexWrapAlignEnd-roRhm`,
	"dFlexWrapAlignStart": `Cancellation-dFlexWrapAlignStart-Jr33r`,
	"justifyContentSpaceBetween": `Cancellation-justifyContentSpaceBetween-pIZZ1`,
	"greyText": `Cancellation-greyText-XvmR7`,
	"tripsReservationPanel": `Cancellation-tripsReservationPanel-Wd3BM`,
	"listContainer": `Cancellation-listContainer-KxXIl`,
	"listTabItem": `Cancellation-listTabItem-w7zy8`,
	"reviewsContainer": `Cancellation-reviewsContainer-JE1p3`,
	"reviewsYourItemsOne": `Cancellation-reviewsYourItemsOne-qsabh`,
	"reviewsYourItemsTwo": `Cancellation-reviewsYourItemsTwo-DByLL`,
	"rightBg": `Cancellation-rightBg-hOs_Z`,
	"commonProfileAvatarLink": `Cancellation-commonProfileAvatarLink-aSIwE`,
	"writtenReviewTitle": `Cancellation-writtenReviewTitle-SfEPk`,
	"reviewTitleLink": `Cancellation-reviewTitleLink-FlPvz`,
	"reviewFlex": `Cancellation-reviewFlex-Shjb1`,
	"noTop": `Cancellation-noTop-fzyAy`,
	"reviewPara": `Cancellation-reviewPara-mERO0`,
	"dFlexColumn": `Cancellation-dFlexColumn-uYZmy`,
	"commonlineCss": `Cancellation-commonlineCss-zN3Wy`,
	"loadBtn": `Cancellation-loadBtn-N2qvd`,
	"vtrTop": `Cancellation-vtrTop-Vfzp1`,
	"reviewHeadingColor": `Cancellation-reviewHeadingColor-T2yJD`,
	"reviewWriteHeading": `Cancellation-reviewWriteHeading-oGJ2j`,
	"noDataImgSize": `Cancellation-noDataImgSize-ptLZP`,
	"justifyCenter": `Cancellation-justifyCenter-dJ7xb`,
	"btnTextBrk": `Cancellation-btnTextBrk-sl6kC`,
	"marginInlineAuto": `Cancellation-marginInlineAuto-LtsBg`,
	"noItemPanel": `Cancellation-noItemPanel-DK431`,
	"textLineBreak": `Cancellation-textLineBreak-N42dI`,
	"displayInlineBlock": `Cancellation-displayInlineBlock-eWqz_`,
	"commonContainerList": `Cancellation-commonContainerList-XWTBf`,
	"adminBorderWithoutPadding": `Cancellation-adminBorderWithoutPadding-PyIwj`,
	"marginRight8": `Cancellation-marginRight8-GBLGL`,
	"adminDotIconBtn": `Cancellation-adminDotIconBtn-laNTt`,
	"commonLinkBorder": `Cancellation-commonLinkBorder-zvaQ9`,
	"commonTabelDropDownBg": `Cancellation-commonTabelDropDownBg-ywsSE`,
	"tabelDropDownBtn": `Cancellation-tabelDropDownBtn-Le1M8`,
	"tableHorizantalLine": `Cancellation-tableHorizantalLine-BvNe9`,
	"backArrowStyle": `Cancellation-backArrowStyle-iLncF`,
	"csvImageSpace": `Cancellation-csvImageSpace-kDxi7`,
	"flexEnd": `Cancellation-flexEnd-ifUGb`,
	"justifyContentFlexEnd": `Cancellation-justifyContentFlexEnd-l2Lc4`,
	"profileAvatarLinkPayment": `Cancellation-profileAvatarLinkPayment-kEOPA`,
	"alignItemBaseline": `Cancellation-alignItemBaseline-yhIE3`,
	"payOutToolTip": `Cancellation-payOutToolTip-e4MQT`,
	"tolltipMargin": `Cancellation-tolltipMargin-gJqY2`,
	"textNoWrap": `Cancellation-textNoWrap-_uHXH`,
	"commonSearchInputFilterContainer": `Cancellation-commonSearchInputFilterContainer-Xwa42`,
	"mobileTableSearch": `Cancellation-mobileTableSearch-msLnE`,
	"mobileTableOnlyLink": `Cancellation-mobileTableOnlyLink-YFc2Z`,
	"linkBtnPrimaryStyle": `Cancellation-linkBtnPrimaryStyle-eO5gj`,
	"dataTableGrid": `Cancellation-dataTableGrid-e0ja5`,
	"paymentDivider": `Cancellation-paymentDivider-IbMPZ`,
	"bulletList": `Cancellation-bulletList-SYfXN`,
	"commonSmallText14": `Cancellation-commonSmallText14-MU35F`,
	"commonSmallText16": `Cancellation-commonSmallText16-VbgZe`,
	"commonSmallText18": `Cancellation-commonSmallText18-bUsAo`,
	"commonSmallText20": `Cancellation-commonSmallText20-CkUCV`,
	"commonSmallText24": `Cancellation-commonSmallText24-Z_BQb`,
	"commonSmallText26": `Cancellation-commonSmallText26-X3N72`,
	"top1": `Cancellation-top1-hOGv4`,
	"top2": `Cancellation-top2-zdezH`,
	"top3": `Cancellation-top3-DNnqM`,
	"topMinus1": `Cancellation-topMinus1-C26MJ`,
	"topMinus2": `Cancellation-topMinus2-xsoXg`,
	"topMinus3": `Cancellation-topMinus3-fDpOX`,
	"textEnd": `Cancellation-textEnd-CJGzV`,
	"textStart": `Cancellation-textStart-orr6s`,
	"flexGrow": `Cancellation-flexGrow-yafyE`,
	"imageUploadDropzoneSection": `Cancellation-imageUploadDropzoneSection-ZTpL9`,
	"imageUploadDropzoneSectionOutline": `Cancellation-imageUploadDropzoneSectionOutline-kPSV_`,
	"commonDropZoneImgContainer": `Cancellation-commonDropZoneImgContainer-FyYAz`,
	"commonDropZoneDefaultImg": `Cancellation-commonDropZoneDefaultImg-nCP4p`,
	"navTabFlex": `Cancellation-navTabFlex-VA94K`,
	"navTabLink": `Cancellation-navTabLink-wQkPO`,
	"activeTabStyle": `Cancellation-activeTabStyle-VW0Yd`,
	"listingCardCarTypeAndTransmissionLabelFlexContainer": `Cancellation-listingCardCarTypeAndTransmissionLabelFlexContainer-SXjUh`,
	"transmissionLabelText": `Cancellation-transmissionLabelText-VKfzh`,
	"carTypeIcon": `Cancellation-carTypeIcon-eHFnb`,
	"textFlow": `Cancellation-textFlow-tEwse`,
	"paymentSticky": `Cancellation-paymentSticky-pwyOu`,
	"btnWidth": `Cancellation-btnWidth-BPvTY`,
	"mobTextCenter": `Cancellation-mobTextCenter-VBVPL`,
	"mobileReviewIconBox": `Cancellation-mobileReviewIconBox-gcMeF`,
	"mrMarginBottom": `Cancellation-mrMarginBottom-hgisA`,
	"mrRemoveMargin": `Cancellation-mrRemoveMargin-qksCZ`,
	"mrListDeletBtnBox": `Cancellation-mrListDeletBtnBox-hYy6z`,
	"mobileFlexContainer": `Cancellation-mobileFlexContainer-q0hnX`,
	"mobileDisplayBlock": `Cancellation-mobileDisplayBlock-YhtiK`,
	"mobileTextCenter": `Cancellation-mobileTextCenter-jy5ei`,
	"displayGrid": `Cancellation-displayGrid-R9bDw`,
	"gridCols2": `Cancellation-gridCols2-gVhag`,
	"gap4": `Cancellation-gap4-Bji3E`,
	"gap6": `Cancellation-gap6-uyy0H`,
	"gap8": `Cancellation-gap8-uDqzv`,
	"gap12": `Cancellation-gap12-PZpIz`,
	"gap16": `Cancellation-gap16-jtbj6`,
	"gap24": `Cancellation-gap24-LQx9t`,
	"columnGap16": `Cancellation-columnGap16-HD5ps`,
	"rowGap18": `Cancellation-rowGap18-Qv8Au`,
	"bt": `Cancellation-bt-AC4XL`,
	"languageBox": `Cancellation-languageBox-dExBc`,
	"languageBtnContainerOne": `Cancellation-languageBtnContainerOne-rdqot`,
	"commonInputGrpDivider": `Cancellation-commonInputGrpDivider-k0XCd`,
	"gridColsTab1": `Cancellation-gridColsTab1-mZfc0`,
	"gapTab0": `Cancellation-gapTab0-lhJrT`,
	"gridColsMobile1": `Cancellation-gridColsMobile1-g65hU`,
	"mobileFlexColumn": `Cancellation-mobileFlexColumn-d75HU`,
	"mobileAlignFlexStretch": `Cancellation-mobileAlignFlexStretch-t6CBt`,
	"Cancel-container-1VRb7": `Cancellation-Cancel-container-1VRb7-BF1Y5`,
	"textAreaInput": `Cancellation-textAreaInput-Iighf`,
	"textTruncate": `Cancellation-textTruncate-ChL34`,
	"profileAvatarSection": `Cancellation-profileAvatarSection-C3Kat`,
	"textRight": `Cancellation-textRight-vMDjT`,
	"textLeft": `Cancellation-textLeft-aWTFv`,
	"cancelBg": `Cancellation-cancelBg-NAGW9`,
	"bgCover": `Cancellation-bgCover-ffsT8`,
	"profileAvatar": `Cancellation-profileAvatar-xaBLP`,
	"carTypeTextSec": `Cancellation-carTypeTextSec-NeQRH`,
	"steeringIcon": `Cancellation-steeringIcon-Pr0sv`,
	"cancelRightCol": `Cancellation-cancelRightCol-S2Gv_`,
	"carType": `Cancellation-carType-kJVAZ`,
	"dotStyle": `Cancellation-dotStyle-yzl3n`,
	"listingTitle": `Cancellation-listingTitle-LmC0T`,
	"listingTitleSec": `Cancellation-listingTitleSec-D2Jjx`,
	"starIcon": `Cancellation-starIcon-ubHSr`,
	"cancelPayDetails": `Cancellation-cancelPayDetails-dlCoa`,
	"guestFundSec": `Cancellation-guestFundSec-bXx6s`,
	"hostFundSec": `Cancellation-hostFundSec-CEJZj`,
	"missedEarningsIcon": `Cancellation-missedEarningsIcon-U7a1N`,
	"rightSecWidth": `Cancellation-rightSecWidth-AvFK0`,
	"leftSecWidth": `Cancellation-leftSecWidth-KmwSh`,
	"strikeOutLine": `Cancellation-strikeOutLine-Iyvf_`,
	"cancellationPolicySec": `Cancellation-cancellationPolicySec-Ja97M`,
	"cancelPolicyContent": `Cancellation-cancelPolicyContent-IE5dN`,
	"lineBg": `Cancellation-lineBg-HtX6k`,
	"displayGridDate": `Cancellation-displayGridDate-aFVjZ`,
	"dateArrowIcon": `Cancellation-dateArrowIcon-vwzgK`,
	"horizontalLineStyle": `Cancellation-horizontalLineStyle-KZQIh`,
	"avatarSpaceRight": `Cancellation-avatarSpaceRight-VINFK`,
	"firstName": `Cancellation-firstName-TdvfK`,
	"cancellationBtnSection": `Cancellation-cancellationBtnSection-gbYPj`,
	"spaceInline": `Cancellation-spaceInline-DfIgd`,
	"profileLinkPadding": `Cancellation-profileLinkPadding-h95o4`,
	"specialPriceText": `Cancellation-specialPriceText-Xd1fk`,
	"specialPriceIcon": `Cancellation-specialPriceIcon-jdCvv`,
	"toolTip": `Cancellation-toolTip-AVJ0l`,
	"toolTipRelativeSection": `Cancellation-toolTipRelativeSection-s6sWa`,
	"faqImage": `Cancellation-faqImage-HYonQ`,
	"mobMarginBtn": `Cancellation-mobMarginBtn-H26uG`,
	"cancelReservationBtn": `Cancellation-cancelReservationBtn-BpeUa`
};
module.exports = ___CSS_LOADER_EXPORT___;
